<!-- Page breadcrumb and Action Form-->
<div class="jobs-detail">
  <div class="row action-form">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-4 align-self-center" *ngIf="pageLoaded">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="/jobs">Jobs</a></li>
          <li class="breadcrumb-item active" aria-current="page">{{ jobDetail.number }} {{ jobDetail.name }}</li>
        </ol>
      </nav>
    </div>
    <div *ngIf="permissionMap?.working_status?.view" class="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-3">
      <fieldset [disabled]="permissionMap?.working_status?.view && !permissionMap?.working_status?.edit">
        <div class="form-group row mx-n2">
          <label for="staticEmail" class="col-5 px-2 col-form-label text-xl-right">Working Status</label>
          <div class="col-7 px-2" *ngIf="workingStatusData.length > 0">
            <select
              class="form-control workingStatus"
              #working_status
              id="working_status"
              [(ngModel)]="working_status_data"
              (change)="setDataToControl('working_status', working_status.value)"
              name="working_status_data"
              [disabled]="(permissionMap?.working_status?.view && !permissionMap?.working_status?.edit) || disableSave">
              <option *ngFor="let item of workingStatusData" value="{{ item.id }}">{{ item.name }}</option>
            </select>
            <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
              <input
                type="text"
                name="working_status_data"
                [(ngModel)]="working_status_data"
                (blur)="setDataToControl('working_status', working_status.value)" />
            </div>
          </div>
        </div>
      </fieldset>
    </div>
    <div class="col-12 col-sm-12 col-md col-lg col-xl-5">
      <div class="d-flex flex-wrap justify-content-center justify-content-xl-end job-right-button-group">
        <div class="form-group mr-1 mb-2" *ngIf="hasPermissions()">
          <a href="javascript:;" class="btn btn-block btn-primary" (click)="generateJobDetailPdf()"> Export </a>
        </div>
        <a href="/jobs" class="btn btn-dark mr-1 mb-2">{{ isDeleted ? 'Close' : 'Cancel' }}</a>
        <button
          type="button"
          class="btn btn-primary mr-1 mb-2"
          (click)="saveJobDetails(jobDetailForm)"
          *ngIf="!isDeleted && userPermissions?.main_job_list?.edit && !disableSave">
          Save
        </button>
        <button
          type="button"
          class="btn btn-primary mr-1 mb-2"
          (click)="saveJobDetails(jobDetailForm, true)"
          *ngIf="!isDeleted && userPermissions?.main_job_list?.edit && !disableSave">
          Save & Close
        </button>
        <button
          type="button"
          class="btn btn-primary mr-1 mb-2"
          (click)="submitToAccounting(jobDetailForm)"
          *ngIf="!isDeleted && userPermissions?.main_job_list?.edit && !disableSave">
          Submit to Accounting
        </button>
        <a
          href="javascript:;"
          data-toggle="modal"
          data-target="#export-job"
          class="btn btn-primary mb-2 mr-1"
          (click)="downloadSageExportPDF()"
          *ngIf="!isDeleted && userPermissions?.main_job_list?.edit && !disableSave"
          >Sage Export</a
        >
        <button
          type="button"
          class="btn btn-outline-primary mr-1 mb-2"
          *ngIf="userPermissions?.locked_fields?.edit && isActiveWorkingStatus && !isDeleted"
          (click)="activateLockedFields()">
          Unlock Fields
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="lastSubmitToAccountingText" class="text-right text-red">
    Job details were submitted to accounting on {{ getAuditTime(lastSubmitToAccountingText) }}
  </div>
  <!-- Page breadcrumb and Action Form End-->
  <!-- Project Tabs -->
  <div class="jobs-tab">
    <!-- Tab Title -->
    <ul class="nav nav-tabs line-tab">
      <li *ngIf="userPermissions?.general_info?.view" class="nav-item" role="presentation">
        <a
          class="nav-link active"
          id="generalTab"
          #generalTab
          data-toggle="tab"
          href="#general-info"
          role="tab"
          aria-selected="true"
          (click)="checkTabEditPermission('general_info')"
          >General Info</a
        >
      </li>
      <li *ngIf="userPermissions?.billing_accounting?.view" class="nav-item" role="presentation">
        <a
          class="nav-link"
          data-toggle="tab"
          href="#billing-accounting"
          role="tab"
          aria-selected="false"
          (click)="checkTabEditPermission('billing_accounting')"
          >Billing & Accounting</a
        >
      </li>
      <li *ngIf="userPermissions?.financials?.view" class="nav-item" role="presentation">
        <a
          class="nav-link"
          data-toggle="tab"
          href="#financials"
          role="tab"
          aria-selected="false"
          (click)="checkTabEditPermission('financials')"
          >Financials</a
        >
      </li>
      <li *ngIf="userPermissions?.audit_trail?.view" class="nav-item" role="presentation">
        <a
          class="nav-link"
          data-toggle="tab"
          href="#audit-trail"
          role="tab"
          aria-selected="false"
          (click)="checkTabEditPermission('audit_trail')"
          >Audit Trail</a
        >
      </li>
    </ul>
    <!-- Tab Title End-->
    <form [formGroup]="jobDetailForm" *ngIf="jobDetailForm">
      <div class="tab-content body-content-scroll scrollbar">
        <!-- General Info -->

        <div
          *ngIf="userPermissions?.general_info?.view"
          class="tab-pane fade show active"
          id="general-info"
          role="tabpanel">
          <div class="card">
            <div class="card-header font-weight-bold">Project Details</div>
            <div class="card-body">
              <fieldset
                [disabled]="
                  (permissionMap.general_info.view && !permissionMap.general_info.edit) || isDeleted || disableSave
                ">
                <div class="row">
                  <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                    <div class="row">
                      <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                        <div class="form-group">
                          <label>Project Number</label>
                          <input type="text" class="form-control" formControlName="number" readonly="" />
                        </div>
                      </div>
                      <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                        <div class="form-group">
                          <label>Project Name *</label>
                          <input
                            type="text"
                            class="form-control"
                            formControlName="name"
                            maxlength="30"
                            [readonly]="isActiveWorkingStatus"
                            #name
                            (input)="setDataToControl('name', name.value)" />
                          <span
                            class="error"
                            *ngIf="jobDetailForm.get('name').hasError('required') && jobDetailForm.get('name').touched">
                            Please provide project name
                          </span>
                        </div>
                      </div>
                      <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                        <input type="text" #hidden1 autofocus tabindex="1" />
                      </div>
                      <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                        <div class="form-group">
                          <label>Owner *</label>
                          <select
                            class="form-control select2 generalLocked hide-initial hide_focus"
                            tabindex="2"
                            formControlName="owner_id"
                            #owner_id
                            (change)="loadSelectedOwnerFacility(owner_id.value)"
                            id="owner_id"
                            [attr.disabled]="isActiveWorkingStatus">
                            <option value="null">Owner</option>
                            <option *ngFor="let item of ownersData" value="{{ item.id }}">{{ item.owner_name }}</option>
                          </select>
                          <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                            <input
                              type="text"
                              formControlName="owner_id"
                              id="owner_id"
                              (blur)="loadSelectedOwnerFacility(owner_id.value)" />
                          </div>
                          <span
                            class="error"
                            *ngIf="
                              jobDetailForm.get('owner_id').hasError('required') &&
                              jobDetailForm.get('owner_id').touched
                            ">
                            Please select owner
                          </span>
                        </div>
                      </div>
                      <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                        <div class="form-group">
                          <label>Facility / Location *</label>
                          <select
                            class="form-control select2 generalLocked"
                            tabindex="3"
                            formControlName="facility_location_id"
                            #facility_location_id
                            id="facility_location_id"
                            (change)="setSelectedFacilityAddress(facility_location_id.value)"
                            placeholder="Facility / Location"
                            [attr.disabled]="isActiveWorkingStatus">
                            <option value="null">Facility / Location</option>
                            <option *ngFor="let item of ownersFacilityData" value="{{ item.id }}">
                              {{ item.facility_name }}
                            </option>
                          </select>
                          <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                            <input
                              type="text"
                              formControlName="facility_location_id"
                              id="facility_location_id"
                              (blur)="setSelectedFacilityAddress(facility_location_id.value)" />
                          </div>
                          <span
                            class="error"
                            *ngIf="
                              jobDetailForm.get('facility_location_id').hasError('required') &&
                              jobDetailForm.get('facility_location_id').touched
                            ">
                            Please select facility / location
                          </span>
                        </div>
                      </div>
                      <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div class="form-group">
                          <label>Job Description / Scope of Work *</label>
                          <textarea
                            class="form-control"
                            rows="4"
                            tabindex="3"
                            formControlName="description"
                            #description
                            (input)="setDataToControl('description', description.value)"
                            placeholder="Job Description / Scope of Work"
                            [readonly]="isActiveWorkingStatus"></textarea>
                          <span
                            class="error"
                            *ngIf="
                              jobDetailForm.get('description').hasError('required') &&
                              jobDetailForm.get('description').touched
                            ">
                            Please provide description
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                    <div class="row">
                      <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                        <div class="form-group">
                          <label>Job Creation Date *</label>
                          <input type="text" class="form-control" [value]="jobCreationData" readonly="" />
                        </div>
                      </div>
                      <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                        <div class="form-group">
                          <label>Submitted by *</label>
                          <input type="text" class="form-control" formControlName="submitted_by_name" readonly="" />
                        </div>
                      </div>
                      <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div class="form-group">
                          <label>Departments on Job *</label>
                          <div class="row row-cols-1 row-cols-sm-3 row-cols-md-3 row-cols-lg-2 row-cols-xl-3">
                            <div class="col" *ngFor="let item of departmentsData; let i = index">
                              <div class="custom-control custom-checkbox mb-2">
                                <input
                                  class="custom-control-input"
                                  type="checkbox"
                                  id="inlineCheckbox{{ item.id }}"
                                  value="{{ item.is_checked == 0 ? 1 : 0 }}"
                                  name="{{ i }}"
                                  [checked]="item.is_checked == 1 ? true : false"
                                  (change)="addRemoveDepartment($event, item)"
                                  [disabled]="isActiveWorkingStatus" />
                                <label class="custom-control-label" for="inlineCheckbox{{ item.id }}">
                                  {{ item.department_short_code }} - {{ item.department_name }}</label
                                >
                              </div>
                              <div #deleteDepartmentModal data-toggle="modal" data-target="#remove-department"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-3 col-sm-3 col-md-3 col-lg-3">
                        <div class="form-group">
                          <label>Select Main Job *</label>
                          <select
                            class="form-control select2 generalLocked"
                            tabindex="4"
                            #mainDepartment
                            (change)="changeIsMainJob(mainDepartment.value)"
                            id="mainDepartment"
                            [attr.disabled]="isActiveWorkingStatus">
                            <option
                              *ngFor="let item of departmentsData"
                              value="{{ item.id }}"
                              [selected]="item.is_main_job">
                              {{ item.department_short_code }} - {{ item.department_name }}
                            </option>
                          </select>
                          <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                            <input type="text" (blur)="changeIsMainJob(mainDepartment.value)" />
                          </div>
                        </div>
                      </div>
                      <div class="col-3 col-sm-3 col-md-3 col-lg-3" style="align-self: center">
                        <div class="form-group">
                          <label>PreCon Involved? *</label>
                          <div>
                            <div class="form-check form-check-inline">
                              <input
                                class="form-check-input disableRadioOnSetUpComplete"
                                type="radio"
                                formControlName="is_precon_involved"
                                id="yes"
                                [value]="1"
                                tabindex="5"
                                autofocus />
                              <label class="form-check-label" for="yes">Yes</label>
                            </div>
                            <div class="form-check form-check-inline">
                              <input
                                class="form-check-input disableRadioOnSetUpComplete"
                                type="radio"
                                formControlName="is_precon_involved"
                                id="no"
                                [value]="0" />
                              <label class="form-check-label" for="no">No</label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-3 col-sm-3 col-md-3 col-lg-3" style="align-self: center">
                        <div class="form-group">
                          <label>Turnover Complete?</label>
                          <div>
                            <div class="form-check form-check-inline">
                              <input
                                class="form-check-input disableRadioOnSetUpComplete"
                                type="radio"
                                formControlName="turnover_complete"
                                id="turnover-yes"
                                [value]="1"
                                tabindex="5"
                                autofocus />
                              <label class="form-check-label" for="turnover-yes">Yes</label>
                            </div>
                            <div class="form-check form-check-inline">
                              <input
                                class="form-check-input disableRadioOnSetUpComplete"
                                type="radio"
                                formControlName="turnover_complete"
                                id="turnover-no"
                                [value]="0"
                                checked="true" />
                              <label class="form-check-label" for="turnover-no">No</label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-3 col-sm-3 col-md-3 col-lg-3">
                        <div class="form-group">
                          <label>Date: </label>
                          <div class="input-group">
                            <input
                              type="text"
                              class="form-control datepicker"
                              #turnover_completion_date
                              formControlName="turnover_completion_date"
                              placeholder="Enter Date"
                              (focus)="setDataToControl('turnover_completion_date', turnover_completion_date.value)"
                              tabindex="121"
                              mask="XX/XX/XXXX"
                              [readonly]="isActiveWorkingStatus" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                    <div class="form-group">
                      <label>Project Start Date *</label>
                      <div class="input-group mb-3">
                        <input
                          type="text"
                          class="form-control datepicker"
                          placeholder="Select Start Date"
                          tabindex="6"
                          #start_date
                          id="start_date"
                          formControlName="start_date"
                          mask="XX/XX/XXXX"
                          (focus)="setDataToControl('start_date', start_date.value)"
                          autocomplete="off"
                          [readonly]="isActiveWorkingStatus" />
                        <div class="input-group-append">
                          <span class="input-group-text"><i class="far fa-calendar-alt"></i></span>
                        </div>
                        <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                          <input
                            type="text"
                            class="start_date"
                            (blur)="setDataToControl('start_date', start_date.value)" />
                        </div>
                        <span
                          class="error"
                          *ngIf="
                            jobDetailForm.get('start_date').hasError('required') &&
                            jobDetailForm.get('start_date').touched
                          ">
                          Please provide start date
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                    <div class="form-group">
                      <label>Project End Date *</label>
                      <div class="input-group mb-3">
                        <input
                          type="text"
                          class="form-control datepicker"
                          placeholder="Select End Date"
                          #end_date
                          formControlName="end_date"
                          id="end_date"
                          mask="XX/XX/XXXX"
                          autocomplete="off"
                          tabindex="7"
                          (focus)="setDataToControl('end_date', end_date.value)"
                          [readonly]="isActiveWorkingStatus" />
                        <div class="input-group-append">
                          <span class="input-group-text"><i class="far fa-calendar-alt"></i></span>
                        </div>
                        <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                          <input type="text" class="end_date" (blur)="setDataToControl('end_date', end_date.value)" />
                        </div>
                        <span
                          class="error"
                          *ngIf="
                            jobDetailForm.get('end_date').hasError('required') && jobDetailForm.get('end_date').touched
                          ">
                          Please provide end date
                        </span>
                        <span
                          class="error"
                          *ngIf="
                            jobDetailForm.get('end_date').hasError('dateCompareValidator') &&
                            (jobDetailForm.get('end_date').touched || jobDetailForm.get('start_date').touched)
                          ">
                          The Project End Date must be after the Project Start Date.
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                    <div class="form-group">
                      <label>Project Type *</label>
                      <select
                        class="form-control select2 aditionalSelect2"
                        tabindex="8"
                        #project_type_id
                        formControlName="project_type_id"
                        (change)="setDataToControl('project_type_id', project_type_id.value)"
                        [attr.disabled]="isActiveWorkingStatus">
                        <option value="">Select Project Type</option>
                        <option *ngFor="let item of projectTypeData" value="{{ item.id }}">
                          {{ item.name }}
                        </option>
                      </select>
                      <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                        <input
                          type="text"
                          formControlName="project_type_id"
                          id="project_type_id"
                          (blur)="setDataToControl('project_type_id', project_type_id.value)" />
                      </div>
                      <span
                        class="error"
                        *ngIf="
                          jobDetailForm.get('project_type_id').hasError('required') &&
                          jobDetailForm.get('project_type_id').touched
                        ">
                        Please select project type
                      </span>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                    <div class="form-group">
                      <label>Project Industry *</label>
                      <select
                        class="form-control select2"
                        tabindex="9"
                        formControlName="project_industry_id"
                        #project_industry_id
                        id="project_industry_id_select"
                        disabled>
                        <option value="0" selected>Project Industry</option>
                        <option *ngFor="let item of projectIndustryData" value="{{ item.id }}">
                          {{ item.name }}
                        </option>
                      </select>
                      <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                        <input
                          type="text"
                          formControlName="project_industry_id"
                          id="project_industry_id"
                          (blur)="setDataToControl('project_industry_id', project_industry_id.value)" />
                      </div>
                      <span
                        class="error"
                        *ngIf="
                          jobDetailForm.get('project_industry_id').hasError('required') &&
                          jobDetailForm.get('project_industry_id').touched
                        ">
                        Please select project industry
                      </span>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
          <div class="card mt-3">
            <div class="card-header font-weight-bold">Jobsite Address</div>

            <fieldset
              [disabled]="
                (permissionMap?.general_info?.view && !permissionMap?.general_info?.edit) || isDeleted || disableSave
              ">
              <div class="card-body">
                <div class="row">
                  <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl">
                    <div class="form-group">
                      <label>Street Address / P.O. Box *</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Street Address / P.O. Box"
                        disabled
                        formControlName="address1" />
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl">
                    <div class="form-group">
                      <label>Apartment, suite, unit, floor, etc</label>
                      <input
                        type="text"
                        class="form-control"
                        disabled
                        formControlName="address2"
                        placeholder="Apartment, suite, unit, floor, etc" />
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl">
                    <div class="form-group">
                      <label>City *</label>
                      <input type="text" class="form-control" placeholder="City" disabled formControlName="city" />
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl">
                    <div class="form-group">
                      <label>State *</label>
                      <select
                        class="form-control select2"
                        disabled
                        formControlName="state_id"
                        #state_id
                        id="state_id_select">
                        <option selected="selected">State</option>
                        <option *ngFor="let item of statesData" value="{{ item.id }}">{{ item.abbreviation }}</option>
                      </select>
                      <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                        <input
                          type="text"
                          formControlName="state_id"
                          id="state_id"
                          (blur)="setDataToControl('state_id', state_id.value)" />
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl">
                    <div class="form-group">
                      <label>Zipcode *</label>
                      <input
                        type="text"
                        class="form-control"
                        name="postal_code"
                        placeholder="Zipcode"
                        disabled
                        formControlName="postal_code"
                        autocomplete="off" />
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-1">
                    <div class="form-group">
                      <label>Code</label>
                      <input
                        type="text"
                        class="form-control"
                        name="code"
                        placeholder="Code"
                        disabled
                        formControlName="code"
                        autocomplete="off" />
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
          <!-- <div class="card mt-3" *ngFor="let item of jobDepartmentData; let i = index;"> -->
          <div formArrayName="department" *ngIf="jobDetailForm.get('department')">
            <div *ngFor="let ctrl of jobDetailForm.get('department')['controls']; let i = index" [formGroupName]="i">
              <div formArrayName="sub_department">
                <div
                  *ngFor="let subdepartment of ctrl.get('sub_department')['controls']; let j = index"
                  [formGroupName]="j"
                  class="department_{{ i }}">
                  <div class="card mt-3">
                    <div class="card-header font-weight-bold" *ngIf="subdepartment.value.is_main_job">
                      Main Job:
                      {{ subdepartment.value.department_name }}
                    </div>
                    <div class="card-header font-weight-bold" *ngIf="!subdepartment.value.is_main_job">
                      Sub-Job:
                      {{ subdepartment.value.department_name }}
                    </div>
                    <div class="card-body">
                      <fieldset [disabled]="!permissionMap?.general_info?.edit || isDeleted">
                        <div class="row">
                          <div class="col-12 col-sm-12 col-md-12 col-lg-7">
                            <div class="row">
                              <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                                <div class="form-group">
                                  <label>Job Number *</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    value="{{ subdepartment.value.number }}-{{
                                      subdepartment.value.department_short_code
                                    }}"
                                    name=""
                                    placeholder="Job Number"
                                    readonly="" />
                                </div>
                              </div>
                              <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                                <div class="form-group">
                                  <label>Project Manager *</label>
                                  <select
                                    class="form-control select2 generalLocked"
                                    formControlName="project_manager_id"
                                    tabindex="{{ 10 + 6 * j + 1 }}"
                                    #project_manager_id
                                    [attr.disabled]="isActiveWorkingStatus || disableSave">
                                    <option selected="selected" value="null">Project Manager</option>
                                    <option *ngFor="let item of projectManagerData" value="{{ item.id }}">
                                      {{
                                        item.employee_alias != null &&
                                        item.employee_alias != '' &&
                                        item.employee_alias != undefined
                                          ? item.employee_alias
                                          : item.first_name + ' ' + item.last_name
                                      }}
                                    </option>
                                  </select>
                                  <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                                    <input
                                      type="text"
                                      formControlName="project_manager_id"
                                      id="project_manager_id"
                                      (blur)="
                                        setDataToGroupControl(
                                          subdepartment,
                                          'project_manager_id',
                                          project_manager_id.value
                                        )
                                      " />
                                  </div>
                                  <span
                                    class="error"
                                    *ngIf="
                                      subdepartment.get('project_manager_id').hasError('required') &&
                                      subdepartment.get('project_manager_id').touched
                                    ">
                                    Please select project manager
                                  </span>
                                </div>
                              </div>
                              <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                                <div class="form-group">
                                  <label>Project Assistant *</label>
                                  <select
                                    class="form-control select2 generalLocked"
                                    formControlName="assistant_id"
                                    tabindex="{{ 10 + 6 * j + 2 }}"
                                    #assistant_id
                                    [attr.disabled]="isActiveWorkingStatus || disableSave">
                                    <option selected="selected" value="null">Project Assistant</option>
                                    <option *ngFor="let item of ProjectAssistantData" value="{{ item.id }}">
                                      {{
                                        item.employee_alias != null &&
                                        item.employee_alias != '' &&
                                        item.employee_alias != undefined
                                          ? item.employee_alias
                                          : item.first_name + ' ' + item.last_name
                                      }}
                                    </option>
                                  </select>
                                  <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                                    <input
                                      type="text"
                                      formControlName="assistant_id"
                                      id="assistant_id"
                                      (blur)="
                                        setDataToGroupControl(subdepartment, 'assistant_id', assistant_id.value)
                                      " />
                                  </div>
                                  <span
                                    class="error"
                                    *ngIf="
                                      subdepartment.get('assistant_id').hasError('required') &&
                                      subdepartment.get('assistant_id').touched
                                    ">
                                    Please select project assistant
                                  </span>
                                </div>
                              </div>
                              <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                                <div class="form-group">
                                  <label>Foreman *</label>
                                  <select
                                    class="form-control select2 generalLocked"
                                    formControlName="foreman_id"
                                    tabindex="{{ 10 + 6 * j + 3 }}"
                                    #foreman_id
                                    [attr.disabled]="isActiveWorkingStatus || disableSave">
                                    <option selected="selected" value="null">Foreman</option>
                                    <option value="0">TBD</option>
                                    <option *ngFor="let item of projectForemanData" value="{{ item.id }}">
                                      {{
                                        item.employee_alias != null &&
                                        item.employee_alias != '' &&
                                        item.employee_alias != undefined
                                          ? item.employee_alias
                                          : item.first_name + ' ' + item.last_name
                                      }}
                                    </option>
                                  </select>
                                  <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                                    <input
                                      type="text"
                                      formControlName="foreman_id"
                                      id="foreman_id"
                                      (blur)="setDataToGroupControl(subdepartment, 'foreman_id', foreman_id.value)" />
                                  </div>
                                  <span
                                    class="error"
                                    *ngIf="
                                      subdepartment.get('foreman_id').hasError('required') &&
                                      subdepartment.get('foreman_id').touched
                                    ">
                                    Please select foreman
                                  </span>
                                </div>
                              </div>
                              <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                                <div class="form-group">
                                  <label>Estimator</label>
                                  <select
                                    class="form-control select2 deletedLocked isEditableGeneralSelect"
                                    formControlName="estimator_id"
                                    tabindex="{{ 10 + 6 * j + 4 }}"
                                    #estimator_id
                                    [attr.disabled]="isDeleted || disableSave">
                                    <option selected=" selected" value="null">Estimator</option>
                                    <option *ngFor="let item of projectEstimatorData" value="{{ item.id }}">
                                      {{
                                        item.employee_alias != null &&
                                        item.employee_alias != '' &&
                                        item.employee_alias != undefined
                                          ? item.employee_alias
                                          : item.first_name + ' ' + item.last_name
                                      }}
                                    </option>
                                  </select>
                                  <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                                    <input
                                      type="text"
                                      formControlName="estimator_id"
                                      id="estimator_id"
                                      (blur)="
                                        setDataToGroupControl(subdepartment, 'estimator_id', estimator_id.value)
                                      " />
                                  </div>
                                </div>
                              </div>
                              <!-- Partner Assistant -->
                              <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                                <div class="form-group">
                                  <label>Partner Assistant</label>
                                  <select
                                    class="form-control select2 generalLocked"
                                    formControlName="partner_assistant_id"
                                    tabindex="{{ 10 + 6 * j + 4 }}"
                                    #partner_assistant_id
                                    [attr.disabled]="isActiveWorkingStatus || disableSave">
                                    <option selected=" selected" value="null">Partner Assistant</option>
                                    <option *ngFor="let item of ProjectAssistantData" value="{{ item.id }}">
                                      {{
                                        item.employee_alias != null &&
                                        item.employee_alias != '' &&
                                        item.employee_alias != undefined
                                          ? item.employee_alias
                                          : item.first_name + ' ' + item.last_name
                                      }}
                                    </option>
                                  </select>
                                  <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                                    <input
                                      type="text"
                                      formControlName="partner_assistant_id"
                                      id="partner_assistant_id"
                                      (blur)="
                                        setDataToGroupControl(
                                          subdepartment,
                                          'partner_assistant_id',
                                          partner_assistant_id.value
                                        )
                                      " />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-sm-12 col-md-12 col-lg-5">
                            <div class="form-group">
                              <label>Department Notes</label>
                              <textarea
                                class="form-control"
                                rows="5"
                                formControlName="notes"
                                [readonly]="disableSave"
                                placeholder="Department Notes"
                                tabindex="{{ 10 + 6 * j + 5 }}"></textarea>
                            </div>
                          </div>
                        </div>
                      </fieldset>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- General Info End-->
        <!-- Billing & Accounting -->
        <div
          *ngIf="userPermissions?.billing_accounting?.view"
          class="tab-pane fade"
          id="billing-accounting"
          role="tabpanel">
          <div class="card">
            <div class="card-header font-weight-bold">Contract Information</div>
            <fieldset
              [disabled]="
                (permissionMap?.billing_accounting?.view && !permissionMap?.billing_accounting?.edit) ||
                isDeleted ||
                disableSave
              ">
              <div class="card-body">
                <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                  <input type="text" #hidden2 autofocus tabindex="100" />
                </div>
                <div class="row">
                  <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                    <div class="row">
                      <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                        <div class="form-group">
                          <label>AR Customer Name *</label>
                          <select
                            class="form-control select2 billingAccountingLocked"
                            formControlName="contact_ar_customer_name_id"
                            #contact_ar_customer_name_id
                            tabindex="101"
                            [attr.disabled]="isActiveWorkingStatus || disableSave"
                            id="contact_ar_customer_name_id">
                            <option selected="" value="null">AR Customer Name</option>
                            <option *ngFor="let item of arCustomerData" value="{{ item.id }}">{{ item.name }}</option>
                          </select>
                          <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                            <input
                              type="text"
                              formControlName="contact_ar_customer_name_id"
                              (blur)="
                                setDataToControl('contact_ar_customer_name_id', contact_ar_customer_name_id.value)
                              " />
                          </div>
                          <span
                            class="error"
                            *ngIf="
                              jobDetailForm.get('contact_ar_customer_name_id').hasError('required') &&
                              jobDetailForm.get('contact_ar_customer_name_id').touched
                            ">
                            Please select ar customer name
                          </span>
                        </div>
                      </div>
                      <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                        <div class="form-group">
                          <label>AR Customer ID *</label>
                          <select
                            class="form-control select2 billingAccountingLocked"
                            formControlName="contact_ar_customer_id"
                            #contact_ar_customer_id
                            tabindex="102"
                            [attr.disabled]="isActiveWorkingStatus || disableSave"
                            id="contact_ar_customer_id">
                            <option selected="" value="null">AR Customer ID</option>
                            <option *ngFor="let item of arCustomerData" value="{{ item.id }}">
                              {{ item.customer_id }}
                            </option>
                          </select>
                          <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                            <input
                              type="text"
                              formControlName="contact_ar_customer_id"
                              (blur)="setDataToControl('contact_ar_customer_id', contact_ar_customer_id.value)" />
                          </div>
                          <span
                            class="error"
                            *ngIf="
                              jobDetailForm.get('contact_ar_customer_id').hasError('required') &&
                              jobDetailForm.get('contact_ar_customer_id').touched
                            ">
                            Please select ar customer id
                          </span>
                        </div>
                      </div>
                      <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                        <div class="form-group">
                          <label>Customer Contract/Purchase Order # *</label>
                          <input
                            type="text"
                            class="form-control"
                            formControlName="contact_purchse_order"
                            placeholder="Customer Contract/Purchase Order #"
                            tabindex="103"
                            [readonly]="isActiveWorkingStatus" />
                          <span
                            class="error"
                            *ngIf="
                              jobDetailForm.get('contact_purchse_order').hasError('required') &&
                              jobDetailForm.get('contact_purchse_order').touched
                            ">
                            Please enter contract/purchase order
                          </span>
                        </div>
                      </div>
                      <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                        <div class="form-group">
                          <label>Type of Billing *</label>
                          <select
                            class="form-control select2 billingAccountingLocked"
                            formControlName="contact_type_of_billing"
                            #contact_type_of_billing
                            tabindex="104"
                            [attr.disabled]="isActiveWorkingStatus || disableSave">
                            <option value="1" selected>Quick Bill</option>
                            <option value="2">Contract</option>
                            <option value="3">AIA</option>
                          </select>
                          <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                            <input
                              type="text"
                              (blur)="setDataToControl('contact_type_of_billing', contact_type_of_billing.value)" />
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                        <div class="form-group">
                          <label>Retainage % *</label>
                          <input
                            type="text"
                            class="form-control"
                            formControlName="contact_retainage_per"
                            placeholder="Retainage %"
                            tabindex="105"
                            [readonly]="isActiveWorkingStatus" />
                          <span
                            class="error"
                            *ngIf="
                              jobDetailForm.get('contact_retainage_per').hasError('required') &&
                              jobDetailForm.get('contact_retainage_per').touched
                            ">
                            Please enter retainage %
                          </span>
                        </div>
                      </div>
                      <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                        <div class="form-group">
                          <label>Billing Due Date Type *</label>
                          <select
                            class="form-control select2Num"
                            #contact_billing_due_date_type
                            formControlName="contact_billing_due_date_type"
                            tabindex="106"
                            [attr.disabled]="isActiveWorkingStatus || disableSave || null">
                            <option value="0">Billing Due Date Type</option>
                            <option *ngFor="let option of billingDueDateTypesData" [value]="option.id">
                              {{ option.code }}
                            </option>
                          </select>
                          <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                            <input
                              type="text"
                              (blur)="
                                setDataToControl('contact_billing_due_date_type', contact_billing_due_date_type.value)
                              " />
                          </div>
                          <span
                            class="error"
                            *ngIf="
                              jobDetailForm.get('contact_billing_due_date_type').hasError('min') &&
                              jobDetailForm.get('contact_billing_due_date_type').touched
                            ">
                            Please select a billing due date type
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-12 col-md-12 col-lg-3">
                    <div class="row">
                      <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div class="form-group">
                          <label>Address</label>
                          <textarea
                            class="form-control ba-textarea-height"
                            disabled
                            formControlName="contact_address1"
                            id="contact_address1"
                            placeholder="Customer Name\nAddress 1\nAddress 2\nCity, State, Zip"
                            rows="4">
                          </textarea>
                        </div>
                      </div>
                      <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div class="form-group">
                          <label>T&M * </label>
                          <div>
                            <div class="form-check form-check-inline">
                              <input
                                class="form-check-input disableRadioOnSetUpComplete"
                                type="radio"
                                formControlName="contact_tm"
                                [value]="1"
                                id="tm-yes"
                                tabindex="107" />
                              <label class="form-check-label" for="tm-yes">Yes</label>
                            </div>
                            <div class="form-check form-check-inline">
                              <input
                                class="form-check-input disableRadioOnSetUpComplete"
                                type="radio"
                                formControlName="contact_tm"
                                [value]="0"
                                checked=""
                                id="tm-no" />
                              <label class="form-check-label" for="tm-no">No</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-12 col-md-12 col-lg-3">
                    <div class="row">
                      <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div class="form-group">
                          <label>Billing Information/Internal Notes</label>
                          <textarea
                            class="form-control ba-textarea-height"
                            formControlName="contact_notes"
                            placeholder="Billing Information/Internal Notes"
                            tabindex="108"
                            rows="4"></textarea>
                        </div>
                      </div>
                    </div>

                    <div class="form-group">
                      <label>Project Contract/Purchase Order</label>
                      <div class="custom-file">
                        <input
                          type="hidden"
                          class="custom-file-input"
                          id="project-contract-purchase-order"
                          formControlName="contract_attach_project_purchase_order"
                          #contract_attach_project_purchase_order
                          (change)="onFileSelect($event, 'contract_attach_project_purchase_order')"
                          multiple />
                        <label
                          class="custom-file-label"
                          for="project-contract-purchase-order"
                          data-browse="Upload file..."
                          data-toggle="modal"
                          data-target="#file-upload"
                          (click)="setFileUploadSection('contract_attach_project_purchase_order')"></label>
                      </div>
                      <div *ngIf="fileList['contract_attach_project_purchase_order'].length > 0">
                        <span
                          *ngFor="
                            let file of fileList['contract_attach_project_purchase_order_filenames'];
                            let i = index
                          "
                          ><a href="{{ fileList['contract_attach_project_purchase_order'][i] }}" target="_blank">{{
                            extractFileString(file)
                          }}</a
                          ><i
                            class="fal fa-times pl-2"
                            (click)="removeFile(i, 'contract_attach_project_purchase_order', file)"
                            *ngIf="file && fileList['contract_attach_project_purchase_order_media_ids'][i]"></i
                          ><br />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
          <div class="card mt-3">
            <div class="card-header font-weight-bold">Labor Details</div>
            <fieldset
              [disabled]="
                (permissionMap?.billing_accounting?.view && !permissionMap?.billing_accounting.edit) ||
                isDeleted ||
                disableSave
              ">
              <div class="card-body">
                <div class="row">
                  <div class="col-12 col-sm-8 col-md-3 col-lg-3 col-xl-3">
                    <div class="form-group">
                      <label>Union Local # *</label>
                      <select
                        class="form-control select2 billingAccountingLocked"
                        formControlName="labor_union_local_id"
                        #labor_union_local_id
                        tabindex="109"
                        [attr.disabled]="isActiveWorkingStatus || disableSave">
                        <option selected="selected" value="null">Union Local #</option>
                        <option *ngFor="let item of unionLocalsData" value="{{ item.id }}">
                          {{ item.union_local_id }}
                          {{ item.description }}
                        </option>
                      </select>
                      <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                        <input
                          type="text"
                          (blur)="setDataToControl('labor_union_local_id', labor_union_local_id.value)" />
                      </div>
                      <span
                        class="error"
                        *ngIf="
                          jobDetailForm.get('labor_union_local_id').hasError('required') &&
                          jobDetailForm.get('labor_union_local_id').touched
                        ">
                        Please enter union local #
                      </span>
                    </div>
                  </div>

                  <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-7">
                    <div class="form-group">
                      <label>Labor Notes</label>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="labor_union_notes"
                        placeholder="Which union will we be working with?"
                        tabindex="110" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2">
                    <div class="form-group">
                      <label>Certified Payroll *</label>
                      <div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input disableRadioOnSetUpComplete"
                            type="radio"
                            formControlName="labor_certified_payroll"
                            [value]="1"
                            checked=""
                            id="certified-payroll-yes"
                            tabindex="111" />
                          <label class="form-check-label" for="certified-payroll-yes">Yes</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input disableRadioOnSetUpComplete"
                            type="radio"
                            formControlName="labor_certified_payroll"
                            [value]="0"
                            id="certified-payroll-no"
                            tabindex="111" />
                          <label class="form-check-label" for="certified-payroll-no">No</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                    <input type="text" class="click-tab" tabindex="112" />
                  </div>
                  <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2">
                    <div class="form-group">
                      <label>Prevailing Wage *</label>
                      <div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input disableRadioOnSetUpComplete"
                            type="radio"
                            formControlName="labor_prevailing_wage"
                            [value]="1"
                            id="prevailing-wage-yes"
                            tabindex="113" />
                          <label class="form-check-label" for="prevailing-wage-yes">Yes</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input disableRadioOnSetUpComplete"
                            type="radio"
                            formControlName="labor_prevailing_wage"
                            [value]="0"
                            id="prevailing-wage-no" />
                          <label class="form-check-label" for="prevailing-wage-no">No</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3">
                    <div class="form-group">
                      <label>Attach Prevailing Wage Schedule</label>
                      <div class="custom-file">
                        <input
                          type="hidden"
                          class="custom-file-input"
                          id="attach-schedule"
                          formControlName="labor_attach_schedule"
                          #labor_attach_schedule
                          (change)="onFileSelect($event, 'labor_attach_schedule')"
                          multiple />
                        <label
                          class="custom-file-label"
                          data-browse="Upload file..."
                          data-toggle="modal"
                          data-target="#file-upload"
                          (click)="setFileUploadSection('labor_attach_schedule')"></label>
                      </div>
                      <div *ngIf="fileList['labor_attach_schedule'].length > 0">
                        <span *ngFor="let file of fileList['labor_attach_schedule_filenames']; let i = index"
                          ><a href="{{ fileList['labor_attach_schedule'][i] }}" target="_blank">{{
                            extractFileString(file)
                          }}</a
                          ><i
                            class="fal fa-times pl-2"
                            (click)="removeFile(i, 'labor_attach_schedule', file)"
                            *ngIf="file && fileList['labor_attach_schedule_media_ids'][i]"></i
                          ><br />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                  <input type="text" class="click-tab" tabindex="114" />
                </div>
                <div class="row">
                  <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-2">
                    <div class="form-group">
                      <label>Per Diem *</label>
                      <div
                        [ngClass]="{
                          disabled: isActiveWorkingStatus && jobDetailForm.get('labor_per_diem').value == 1
                        }">
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input disableRadioOnSetUpComplete"
                            type="radio"
                            formControlName="labor_per_diem"
                            [value]="1"
                            id="per-diem-yes"
                            tabindex="115"
                            (click)="setDisableStates(true, 'labor_per_diem')" />
                          <label class="form-check-label" for="per-diem-yes">Yes</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input disableRadioOnSetUpComplete"
                            type="radio"
                            formControlName="labor_per_diem"
                            [value]="0"
                            id="per-diem-no"
                            (click)="setDisableStates(false, 'labor_per_diem')" />
                          <label class="form-check-label" for="per-diem-no">No</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                    <input type="text" class="click-tab" tabindex="116" />
                  </div>
                  <div class="col-12 col-sm-12 col-md-9 col-lg-4 col-xl-3">
                    <div class="form-group">
                      <label>Per Diem Notes</label>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="labor_per_diem_notes"
                        placeholder="Per Diem Notes"
                        tabindex="117"
                        [readonly]="isActiveWorkingStatus && jobDetailForm.get('labor_per_diem').value == 1" />
                      <span
                        class="error"
                        *ngIf="
                          jobDetailForm.get('labor_per_diem_notes').hasError('confirmedValidator') &&
                          jobDetailForm.get('labor_per_diem_notes').touched
                        ">
                        Please enter per diem notes</span
                      >
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                    <div class="form-group">
                      <label>Per Diem Documents</label>
                      <div class="custom-file">
                        <input
                          type="hidden"
                          class="custom-file-input"
                          id="per-deim-documents"
                          formControlName="additional_per_diem_documents"
                          #additional_per_diem_documents
                          (change)="onFileSelect($event, 'additional_per_diem_documents')"
                          multiple />
                        <label
                          class="custom-file-label"
                          for="per-deim-documents"
                          data-browse="Upload file..."
                          data-toggle="modal"
                          data-target="#file-upload"
                          (click)="setFileUploadSection('additional_per_diem_documents')"></label>
                      </div>
                      <div *ngIf="fileList['additional_per_diem_documents'].length > 0">
                        <span *ngFor="let file of fileList['additional_per_diem_documents_filenames']; let i = index"
                          ><a href="{{ fileList['additional_per_diem_documents'][i] }}" target="_blank">{{
                            extractFileString(file)
                          }}</a
                          ><i
                            class="fal fa-times pl-2"
                            (click)="removeFile(i, 'additional_per_diem_documents', file)"
                            *ngIf="file && fileList['additional_per_diem_documents_media_ids'][i]"></i
                          ><br />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2">
                    <div class="form-group">
                      <label>Union Targeting *</label>
                      <div
                        [ngClass]="{
                          disabled: isActiveWorkingStatus && jobDetailForm.get('additional_union_targeting').value == 1
                        }">
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input disableRadioOnSetUpComplete"
                            type="radio"
                            formControlName="additional_union_targeting"
                            [value]="1"
                            checked=""
                            id="union-targeting-yes"
                            tabindex="118"
                            (click)="setDisableStates(true, 'additional_union_targeting')" />
                          <label class="form-check-label" for="union-targeting-yes">Yes</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input disableRadioOnSetUpComplete"
                            type="radio"
                            formControlName="additional_union_targeting"
                            [value]="0"
                            id="union-targeting-no"
                            (click)="setDisableStates(false, 'additional_union_targeting')"
                            tabindex="120" />
                          <label class="form-check-label" for="union-targeting-no">No</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                    <div class="form-group">
                      <label>Date Contract Requested</label>
                      <div
                        class="input-group"
                        [ngClass]="{
                          disabled: isActiveWorkingStatus && jobDetailForm.get('additional_union_targeting').value == 1,
                          'input-group': true
                        }">
                        <input
                          type="text"
                          class="form-control datepicker"
                          #additional_date_contract_requested
                          formControlName="additional_date_contract_requested"
                          placeholder="Date Contract Requested"
                          (blur)="
                            setDataToControl(
                              'additional_date_contract_requested',
                              additional_date_contract_requested.value
                            )
                          "
                          tabindex="121"
                          mask="XX/XX/XXXX"
                          [readonly]="
                            isActiveWorkingStatus && jobDetailForm.get('additional_union_targeting').value == 1
                          " />
                        <div class="input-group-append">
                          <span class="input-group-text"><i class="far fa-calendar-alt"></i></span>
                        </div>
                        <span
                          class="error"
                          *ngIf="
                            jobDetailForm.get('additional_date_contract_requested').hasError('confirmedValidator') &&
                            jobDetailForm.get('additional_date_contract_requested').touched
                          ">
                          Please enter date contract requested</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                    <div class="form-group">
                      <label>Attach Targeting Contract</label>
                      <div class="custom-file">
                        <input
                          type="hidden"
                          class="custom-file-input"
                          id="attach-targeting-schedule"
                          formControlName="additional_attach_targeting_contact"
                          #additional_attach_targeting_contact
                          (change)="onFileSelect($event, 'additional_attach_targeting_contact')"
                          multiple />
                        <label
                          class="custom-file-label"
                          for="attach-targeting-schedule"
                          data-browse="Upload file..."
                          data-toggle="modal"
                          data-target="#file-upload"
                          (click)="setFileUploadSection('additional_attach_targeting_contact')"></label>
                      </div>
                      <div *ngIf="fileList['additional_attach_targeting_contact'].length > 0">
                        <span
                          *ngFor="let file of fileList['additional_attach_targeting_contact_filenames']; let i = index"
                          ><a href="{{ fileList['additional_attach_targeting_contact'][i] }}" target="_blank">{{
                            extractFileString(file)
                          }}</a
                          ><i
                            class="fal fa-times pl-2"
                            (click)="removeFile(i, 'additional_attach_targeting_contact', file)"
                            *ngIf="file && fileList['additional_attach_targeting_contact_media_ids'][i]"></i
                          ><br />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
          <div class="card mt-3">
            <div class="card-header font-weight-bold">Sales Tax Information</div>
            <fieldset
              [disabled]="
                (permissionMap?.billing_accounting?.view && !permissionMap?.billing_accounting?.edit) ||
                isDeleted ||
                disableSave
              ">
              <div class="card-body">
                <div class="row">
                  <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3">
                    <div class="form-group">
                      <label>Tax Status *</label>
                      <select
                        class="form-control select2 billingAccountingLocked"
                        formControlName="sales_tax_status_id"
                        #sales_tax_status_id
                        tabindex="123"
                        [attr.disabled]="isActiveWorkingStatus || disableSave">
                        <option *ngFor="let item of taxStatusData" value="{{ item.id }}">
                          {{ item.name }}
                        </option>
                      </select>
                      <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                        <input
                          type="text"
                          (blur)="setDataToControl('sales_tax_status_id', sales_tax_status_id.value)" />
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-5 col-lg-5 col-xl-6">
                    <div class="form-group">
                      <label>Exemption Notes</label>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="sales_tax_exemption_notes"
                        placeholder="Exemption Notes"
                        tabindex="124" />
                    </div>
                  </div>
                  <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-3">
                    <div class="form-group">
                      <label>Attach Exemption Certificate</label>
                      <div class="custom-file">
                        <input
                          type="hidden"
                          class="custom-file-input"
                          id="exemption-certificate"
                          formControlName="sales_tax_attach_exemption_certificate"
                          #sales_tax_attach_exemption_certificate
                          (change)="onFileSelect($event, 'sales_tax_attach_exemption_certificate')"
                          multiple />
                        <label
                          class="custom-file-label"
                          for="exemption-certificate"
                          data-browse="Upload file..."
                          data-toggle="modal"
                          data-target="#file-upload"
                          (click)="setFileUploadSection('sales_tax_attach_exemption_certificate')"></label>
                      </div>
                      <div *ngIf="fileList['sales_tax_attach_exemption_certificate'].length > 0">
                        <span
                          *ngFor="
                            let file of fileList['sales_tax_attach_exemption_certificate_filenames'];
                            let i = index
                          "
                          ><a href="{{ fileList['sales_tax_attach_exemption_certificate'][i] }}" target="_blank">{{
                            extractFileString(file)
                          }}</a
                          ><i
                            class="fal fa-times pl-2"
                            (click)="removeFile(i, 'sales_tax_attach_exemption_certificate', file)"
                            *ngIf="file && fileList['sales_tax_attach_exemption_certificate_media_ids'][i]"></i
                          ><br />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
          <div class="card mt-3">
            <div class="card-header font-weight-bold">Additional Billing Details</div>
            <fieldset
              [disabled]="
                (permissionMap?.billing_accounting?.view && !permissionMap?.billing_accounting?.edit) ||
                isDeleted ||
                disableSave
              ">
              <div class="card-body">
                <div class="row">
                  <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
                    <div class="form-group">
                      <label>Billing/Contact Name</label>
                      <div>
                        <select
                          class="form-control select2 deletedLocked isEditableBillingSelect"
                          formControlName="additional_billing_contact_name"
                          #additional_billing_contact_name
                          id="additional_billing_contact_name"
                          tabindex="126">
                          <option *ngFor="let item of billingContacts" value="{{ item.contactName }}">
                            {{ item.contactName }}
                          </option>
                        </select>
                        <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                          <input
                            type="text"
                            formControlName="additional_billing_contact_name"
                            (blur)="
                              setDataToControl('additional_billing_contact_name', additional_billing_contact_name.value)
                            " />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
                    <div class="form-group">
                      <label>Contact Email</label>
                      <input
                        type="email"
                        class="form-control"
                        formControlName="additional_contact_email"
                        #additional_contact_email
                        id="additional_contact_email"
                        placeholder="Contact Email"
                        tabindex="127" />
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
                    <div class="form-group">
                      <label>Contact Phone Number</label>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="additional_contact_phone_number"
                        #additional_contact_phone_number
                        id="additional_contact_phone_number"
                        placeholder="Contact Phone Number"
                        tabindex="128"
                        mask="(XXX) XXX-XXXX"
                        clearIfNotMatch="true" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                    <div class="form-group">
                      <label>Invoice Delivery Method</label>
                      <div>
                        <select
                          class="form-control select2 deletedLocked isEditableBillingSelect"
                          formControlName="additional_invoice_delivery_method"
                          tabindex="129"
                          #additional_invoice_delivery_method>
                          <option value="1">Mail</option>
                          <option value="2" selected>Email</option>
                          <option value="3">Portal</option>
                        </select>
                        <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                          <input
                            type="text"
                            formControlName="additional_invoice_delivery_method"
                            id="additional_invoice_delivery_method"
                            (blur)="
                              setDataToControl(
                                'additional_invoice_delivery_method',
                                additional_invoice_delivery_method.value
                              )
                            " />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                    <div class="form-group">
                      <label>Portal Website / Billing Email</label>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="additional_portal_website_address"
                        #additional_portal_website_address
                        id="additional_portal_website_address"
                        placeholder="Portal Website / Billing Email"
                        tabindex="132" />
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                    <div class="form-group">
                      <label>Portal Login</label>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="additional_portal_login"
                        placeholder="Portal Login"
                        tabindex="133" />
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                    <div class="form-group">
                      <label>Portal Password</label>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="additional_portal_password"
                        placeholder="Portal Password"
                        tabindex="134" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6 col-sm-6 col-md-3 col-lg">
                    <div class="form-group">
                      <label>Backup Required</label>
                      <div role="radiogroup">
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            formControlName="additional_backup_required"
                            [value]="1"
                            checked=""
                            id="backup-required-yes"
                            (change)="setDisableStates(true)"
                            tabindex="135" />
                          <label class="form-check-label" for="backup-required-yes">Yes</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            formControlName="additional_backup_required"
                            [value]="0"
                            id="backup-required-no"
                            (change)="setDisableStates(false)"
                            tabindex="136" />
                          <label class="form-check-label" for="backup-required-no">No</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="disableBakcupFields" class="col-6 col-sm-6 col-md-3 col-lg">
                    <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                      <input type="text" class="click-tab" tabindex="137" />
                    </div>
                    <div class="form-group">
                      <label>Sworn Statement</label>
                      <div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            formControlName="additional_sworn_statement"
                            [value]="1"
                            id="sworn-statement-yes"
                            tabindex="138" />
                          <label class="form-check-label" for="sworn-statement-yes">Yes</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            formControlName="additional_sworn_statement"
                            [value]="0"
                            checked=""
                            id="sworn-statement-no" />
                          <label class="form-check-label" for="sworn-statement-no">No</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="!disableBakcupFields" class="col-6 col-sm-6 col-md-3 col-lg">
                    <div class="form-group">
                      <label>Sworn Statement</label>
                      <div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            formControlName="additional_sworn_statement"
                            [value]="1"
                            [attr.disabled]="disableBakcupFields || disableSave"
                            id="sworn-statement-yes"
                            tabindex="138" />
                          <label class="form-check-label" for="sworn-statement-yes">Yes</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            formControlName="additional_sworn_statement"
                            [value]="0"
                            checked=""
                            [attr.disabled]="disableBakcupFields || disableSave"
                            id="sworn-statement-no" />
                          <label class="form-check-label" for="sworn-statement-no">No</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="disableBakcupFields" class="col-6 col-sm-6 col-md-3 col-lg">
                    <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                      <input type="text" class="click-tab" tabindex="139" />
                    </div>
                    <div class="form-group">
                      <label>Waivers</label>
                      <div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            formControlName="additional_waivers"
                            [value]="1"
                            id="waivers-yes"
                            tabindex="140" />
                          <label class="form-check-label" for="waivers-yes">Yes</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            formControlName="additional_waivers"
                            [value]="0"
                            checked=""
                            id="waivers-no" />
                          <label class="form-check-label" for="waivers-no">No</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="!disableBakcupFields" class="col-6 col-sm-6 col-md-3 col-lg">
                    <div class="form-group">
                      <label>Waivers</label>
                      <div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            formControlName="additional_waivers"
                            [value]="1"
                            disabled=""
                            id="waivers-yes"
                            tabindex="140" />
                          <label class="form-check-label" for="waivers-yes">Yes</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            formControlName="additional_waivers"
                            [value]="0"
                            checked=""
                            disabled=""
                            id="waivers-no" />
                          <label class="form-check-label" for="waivers-no">No</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="disableBakcupFields" class="col-6 col-sm-6 col-md-3 col-lg">
                    <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                      <input type="text" class="click-tab" tabindex="141" />
                    </div>
                    <div class="form-group">
                      <label>T&M Backup</label>
                      <div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            formControlName="additional_tm_backup"
                            [value]="1"
                            id="tm-backup-yes"
                            tabindex="142" />
                          <label class="form-check-label" for="tm-backup-yes">Yes</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            formControlName="additional_tm_backup"
                            [value]="0"
                            checked=""
                            id="tm-backup-no" />
                          <label class="form-check-label" for="tm-backup-no">No</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="!disableBakcupFields" class="col-6 col-sm-6 col-md-3 col-lg">
                    <div class="form-group">
                      <label>T&M Backup</label>
                      <div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            formControlName="additional_tm_backup"
                            [value]="1"
                            disabled=""
                            id="tm-backup-yes"
                            tabindex="141" />
                          <label class="form-check-label" for="tm-backup-yes">Yes</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            formControlName="additional_tm_backup"
                            [value]="0"
                            checked=""
                            disabled=""
                            id="tm-backup-no"
                            tabindex="142" />
                          <label class="form-check-label" for="tm-backup-no">No</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="disableBakcupFields" class="col-6 col-sm-6 col-md-3 col-lg">
                    <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                      <input type="text" class="click-tab" tabindex="143" />
                    </div>
                    <div class="form-group">
                      <label>Timesheets</label>
                      <div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            formControlName="additional_timesheets"
                            [value]="1"
                            id="timesheets-yes"
                            tabindex="144" />
                          <label class="form-check-label" for="timesheets-yes">Yes</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            formControlName="additional_timesheets"
                            [value]="0"
                            checked=""
                            id="timesheets-no" />
                          <label class="form-check-label" for="timesheets-no">No</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="!disableBakcupFields" class="col-6 col-sm-6 col-md-3 col-lg">
                    <div class="form-group">
                      <label>Timesheets</label>
                      <div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            formControlName="additional_timesheets"
                            [value]="1"
                            disabled=""
                            id="timesheets-yes"
                            tabindex="143" />
                          <label class="form-check-label" for="timesheets-yes">Yes</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            formControlName="additional_timesheets"
                            [value]="0"
                            checked=""
                            disabled=""
                            id="timesheets-no"
                            tabindex="144" />
                          <label class="form-check-label" for="timesheets-no">No</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="disableBakcupFields" class="col-6 col-sm-6 col-md-3 col-lg">
                    <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                      <input type="text" class="click-tab" tabindex="145" />
                    </div>
                    <div class="form-group">
                      <label>Other</label>
                      <div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            formControlName="additional_other"
                            [value]="1"
                            id="other-yes"
                            tabindex="146" />
                          <label class="form-check-label" for="other-yes">Yes</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            formControlName="additional_other"
                            [value]="0"
                            checked=""
                            id="other-no" />
                          <label class="form-check-label" for="other-no">No</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="!disableBakcupFields" class="col-6 col-sm-6 col-md-3 col-lg">
                    <div class="form-group">
                      <label>Other</label>
                      <div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            formControlName="additional_other"
                            [value]="1"
                            disabled=""
                            id="other-yes"
                            tabindex="145" />
                          <label class="form-check-label" for="other-yes">Yes</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            formControlName="additional_other"
                            [value]="0"
                            checked=""
                            disabled=""
                            id="other-no"
                            tabindex="146" />
                          <label class="form-check-label" for="other-no">No</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-sm-12 col-md-8 col-lg-6">
                    <div class="form-group">
                      <label>Additional Portal Information/Notes</label>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="additional_portal_notes"
                        #additional_portal_notes
                        id="additional_portal_notes"
                        placeholder="Additional Portal Information/Notes"
                        tabindex="147" />
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
          <div class="card mt-3">
            <div class="card-header font-weight-bold">Additional Contract Details</div>
            <fieldset
              [disabled]="
                (permissionMap?.billing_accounting?.view && !permissionMap?.billing_accounting?.edit) ||
                isDeleted ||
                disableSave
              ">
              <div class="card-body">
                <div class="row">
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div class="form-group">
                      <label>Contract Signed</label>
                      <div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            formControlName="additional_contact_signed"
                            [value]="1"
                            id="contract-signed-yes"
                            tabindex="148" />
                          <label class="form-check-label" for="contract-signed-yes">Yes</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            formControlName="additional_contact_signed"
                            [value]="0"
                            checked=""
                            id="contract-signed-no"
                            tabindex="149" />
                          <label class="form-check-label" for="contract-signed-no">No</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2">
                    <div class="form-group">
                      <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                        <input type="text" class="click-tab" tabindex="150" />
                      </div>
                      <label>OCIP</label>
                      <div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            formControlName="additional_ocip"
                            [value]="1"
                            id="ocip-yes"
                            tabindex="151" />
                          <label class="form-check-label" for="ocip-yes">Yes</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            formControlName="additional_ocip"
                            [value]="0"
                            checked=""
                            id="ocip-no"
                            tabindex="152" />
                          <label class="form-check-label" for="ocip-no">No</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                    <div class="form-group">
                      <label>OCIP Portal Site</label>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="additional_ocip_website_address"
                        placeholder="OCIP Portal Site"
                        tabindex="132" />
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                    <div class="form-group">
                      <label>Portal Log In</label>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="additional_portal_login_address"
                        placeholder="Portal Log In"
                        tabindex="132" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2">
                    <div class="form-group">
                      <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                        <input type="text" class="click-tab" tabindex="153" />
                      </div>
                      <label>Bond Required</label>
                      <div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            formControlName="additional_bond_required"
                            [value]="1"
                            checked=""
                            id="bond-required-yes"
                            tabindex="154"
                            (change)="enableTabRequired(true)" />
                          <label class="form-check-label" for="bond-required-yes">Yes</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            formControlName="additional_bond_required"
                            [value]="0"
                            id="bond-required-no"
                            tabindex="155"
                            (change)="enableTabRequired(false)" />
                          <label class="form-check-label" for="bond-required-no">No</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                    <div class="form-group">
                      <label>Bond Received Date</label>
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control datepicker"
                          formControlName="additional_bond_received_date"
                          #additional_bond_received_date
                          placeholder="Bond Received Date"
                          tabindex="156"
                          mask="XX/XX/XXXX"
                          *ngIf="enableTabBondRequired"
                          (blur)="
                            setDataToControl('additional_bond_received_date', additional_bond_received_date.value)
                          " />
                        <input
                          type="text"
                          class="form-control datepicker"
                          formControlName="additional_bond_received_date"
                          #additional_bond_received_date
                          placeholder="Bond Received Date"
                          *ngIf="!enableTabBondRequired"
                          mask="XX/XX/XXXX"
                          (blur)="
                            setDataToControl('additional_bond_received_date', additional_bond_received_date.value)
                          " />
                        <div class="input-group-append">
                          <span class="input-group-text"><i class="far fa-calendar-alt"></i></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                    <div class="form-group">
                      <label>Bond Signed Date</label>
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control datepicker"
                          formControlName="additional_bond_signed_date"
                          #additional_bond_signed_date
                          placeholder="Bond Signed Date"
                          *ngIf="enableTabBondRequired"
                          tabindex="157"
                          mask="XX/XX/XXXX"
                          (blur)="setDataToControl('additional_bond_signed_date', additional_bond_signed_date.value)" />
                        <input
                          type="text"
                          class="form-control datepicker"
                          formControlName="additional_bond_signed_date"
                          #additional_bond_signed_date
                          placeholder="Bond Signed Date"
                          *ngIf="!enableTabBondRequired"
                          mask="XX/XX/XXXX"
                          (blur)="setDataToControl('additional_bond_signed_date', additional_bond_signed_date.value)" />
                        <div class="input-group-append">
                          <span class="input-group-text"><i class="far fa-calendar-alt"></i></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 offset-md-4 offset-lg-0">
                    <div class="form-group">
                      <label>Bond Sent Date</label>
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control datepicker"
                          formControlName="additional_bond_sent_date"
                          #additional_bond_sent_date
                          placeholder="Bond Sent Date"
                          *ngIf="enableTabBondRequired"
                          tabindex="158"
                          mask="XX/XX/XXXX"
                          (blur)="setDataToControl('additional_bond_sent_date', additional_bond_sent_date.value)" />
                        <input
                          type="text"
                          class="form-control datepicker"
                          formControlName="additional_bond_sent_date"
                          #additional_bond_sent_date
                          placeholder="Bond Sent Date"
                          *ngIf="!enableTabBondRequired"
                          mask="XX/XX/XXXX"
                          (blur)="setDataToControl('additional_bond_sent_date', additional_bond_sent_date.value)" />
                        <div class="input-group-append">
                          <span class="input-group-text"><i class="far fa-calendar-alt"></i></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                  <input type="text" class="click-tab" tabindex="159" />
                </div>
                <div class="row">
                  <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2">
                    <div class="form-group">
                      <label>Insurance Cert Required</label>
                      <div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            formControlName="additional_insurance_cert_required"
                            [value]="1"
                            checked=""
                            id="insurance-cert-yes"
                            tabindex="160"
                            (change)="enableInsuranceRequired(true)" />
                          <label class="form-check-label" for="insurance-cert-yes">Yes</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            formControlName="additional_insurance_cert_required"
                            [value]="0"
                            id="insurance-cert-no"
                            tabindex="161"
                            (change)="enableInsuranceRequired(false)" />
                          <label class="form-check-label" for="insurance-cert-no">No</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                    <div class="form-group">
                      <label>Insurance Cert Received Date</label>
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control datepicker"
                          formControlName="additional_insurance_cert_received_date"
                          #additional_insurance_cert_received_date
                          placeholder="Insurance Cert Received Date"
                          tabindex="162"
                          *ngIf="enableTabInsuranceRequired"
                          mask="XX/XX/XXXX"
                          (blur)="
                            setDataToControl(
                              'additional_insurance_cert_received_date',
                              additional_insurance_cert_received_date.value
                            )
                          " />
                        <input
                          type="text"
                          class="form-control datepicker"
                          formControlName="additional_insurance_cert_received_date"
                          *ngIf="!enableTabInsuranceRequired"
                          #additional_insurance_cert_received_date
                          placeholder="Insurance Cert Received Date"
                          mask="XX/XX/XXXX"
                          (blur)="
                            setDataToControl(
                              'additional_insurance_cert_received_date',
                              additional_insurance_cert_received_date.value
                            )
                          " />
                        <div class="input-group-append">
                          <span class="input-group-text"><i class="far fa-calendar-alt"></i></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                    <div class="form-group">
                      <label>Insurance Cert Sent Date</label>
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control datepicker"
                          mask="XX/XX/XXXX"
                          #additional_insurance_cert_sent_date
                          formControlName="additional_insurance_cert_sent_date"
                          placeholder="Insurance Cert Sent Date"
                          tabindex="163"
                          *ngIf="enableTabInsuranceRequired"
                          (blur)="
                            setDataToControl(
                              'additional_insurance_cert_sent_date',
                              additional_insurance_cert_sent_date.value
                            )
                          " />
                        <input
                          type="text"
                          class="form-control datepicker"
                          mask="XX/XX/XXXX"
                          #additional_insurance_cert_sent_date
                          formControlName="additional_insurance_cert_sent_date"
                          placeholder="Insurance Cert Sent Date"
                          *ngIf="!enableTabInsuranceRequired"
                          (blur)="
                            setDataToControl(
                              'additional_insurance_cert_sent_date',
                              additional_insurance_cert_sent_date.value
                            )
                          " />
                        <div class="input-group-append">
                          <span class="input-group-text"><i class="far fa-calendar-alt"></i></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                  <input type="text" class="click-tab" tabindex="164" *ngIf="!enableTabInsuranceRequired" />
                </div>
                <div class="row">
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div class="form-group">
                      <label>Permits Required</label>
                      <div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            formControlName="additional_permits_required"
                            [value]="1"
                            id="permits-required-yes"
                            tabindex="165" />
                          <label class="form-check-label" for="permits-required-yes">Yes</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            formControlName="additional_permits_required"
                            [value]="0"
                            checked=""
                            id="permits-required-no"
                            tabindex="166" />
                          <label class="form-check-label" for="permits-required-no">No</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div formArrayName="permit_type" *ngIf="jobDetailForm && jobDetailForm.get('permit_type')">
                  <div
                    *ngFor="let ctrl of jobDetailForm.get('permit_type')['controls']; let i = index"
                    [formGroupName]="i">
                    <div formArrayName="indi_permittype">
                      <div
                        *ngFor="let permittype of ctrl.get('indi_permittype')['controls']; let j = index"
                        [formGroupName]="j"
                        class="permittype_{{ i }}">
                        <div class="row align-items-end">
                          <div class="col-12 col-sm-5 col-md-4 col-lg-4">
                            <div class="form-group">
                              <label>Permit Type {{ j + 1 }}</label>
                              <input
                                type="text"
                                class="form-control"
                                formControlName="permit_type"
                                #permit_type
                                placeholder="Permit Type"
                                tabindex="{{ 175 + 2 * j }}"
                                (keyup)="setDataToPermitControl(permittype, 'permit_type', permit_type.value, j)" />
                            </div>
                          </div>
                          <div class="col-12 col-sm-5 col-md-4 col-lg-4">
                            <div class="form-group">
                              <label>Permit Type {{ j + 1 }} Rec’d Date</label>
                              <div class="input-group">
                                <input
                                  type="text"
                                  class="form-control datepicker"
                                  formControlName="record_date"
                                  #record_date
                                  placeholder="Permit Type {{ j + 1 }} Rec’d Date"
                                  tabindex="{{ 175 + 2 * j + 1 }}"
                                  mask="XX/XX/XXXX"
                                  (blur)="setDataToPermitControl(permittype, 'record_date', record_date.value, j)" />
                                <div class="input-group-append">
                                  <span class="input-group-text"><i class="far fa-calendar-alt"></i></span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-sm-2 col-md-4 col-lg-4">
                            <div class="form-group">
                              <a
                                href="javascript:;"
                                class="remove"
                                (click)="deletePermitType(ctrl, permittype.value.id, j)"
                                ><i class="far fa-times-circle"></i
                              ></a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="add-fild" *ngIf="!disableSave">
                      <a
                        href="javascript:;"
                        class="font-weight-bold text-primary"
                        *ngIf="!isDeleted"
                        (click)="addAdditionalPermitTypeInfoSameEditTime(ctrl.get('indi_permittype'))"
                        >+ Add Permit Type</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
        <!-- Billing & Accounting End-->
        <!-- Financials -->
        <div *ngIf="userPermissions?.financials?.view" class="tab-pane fade" id="financials" role="tabpanel">
          <div class="card">
            <div class="card-body">
              <fieldset
                [disabled]="
                  (permissionMap?.financials?.view && !permissionMap?.financials?.edit) || isDeleted || disableSave
                ">
                <div class="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="supplementalInfo"
                    #supplementalInfo
                    checked=""
                    formControlName="financial_supplemental_info"
                    tabindex="301" />
                  <label class="custom-control-label" for="supplementalInfo">Supplemental info? </label>
                </div>
              </fieldset>
            </div>
          </div>
          <div class="card">
            <div class="card-header font-weight-bold">Job Contract & Cost Breakdown</div>
            <div class="card-body p-0">
              <div class="table-responsive">
                <div formArrayName="department" *ngIf="jobDetailForm && jobDetailForm.get('department')">
                  <div
                    *ngFor="let ctrl of jobDetailForm.get('department')['controls']; let i = index"
                    [formGroupName]="i">
                    <div formArrayName="sub_department">
                      <table class="table m-0 border-0">
                        <thead>
                          <tr>
                            <th>Job Number</th>
                            <th>Contract Total</th>
                            <th>Estimated Cost</th>
                            <th>Est. Profit</th>
                            <th>Est. GM</th>
                            <th>Est. Hours</th>
                            <th>Prod Units</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            *ngFor="let subdepartment of ctrl.get('sub_department')['controls']; let j = index"
                            [formGroupName]="j"
                            class="department_{{ i }}">
                            <td width="180">
                              {{ subdepartment.value.number }}-{{ subdepartment.value.department_short_code }}
                            </td>
                            <td width="200">
                              <input
                                type="text"
                                [readonly]="
                                  (permissionMap?.financials?.view && !permissionMap?.financials?.edit) ||
                                  isDeleted ||
                                  disableSave
                                "
                                formControlName="contract_total"
                                mask="separator"
                                thousandSeparator=","
                                [prefix]="subdepartment.value.contract_total ? '$' : ''"
                                class="form-control form-control-sm text-right"
                                tabindex="{{ 302 + j }}" />
                            </td>
                            <td width="210">
                              {{
                                getTotalOfDepartment('estimated_cost', subdepartment.value.department_id)
                                  | number: '1.2-2'
                              }}
                            </td>
                            <td width="210">
                              {{
                                subdepartment.value.contract_total -
                                  getTotalOfDepartment(
                                    'estimated_cost',
                                    subdepartment.value.department_id,
                                    subdepartment.value.contract_total
                                  ) | number: '1.2-2'
                              }}
                            </td>
                            <td
                              width="120"
                              *ngIf="
                                subdepartment.value.contract_total != '' &&
                                subdepartment.value.contract_total != null &&
                                subdepartment.value.contract_total != 0 &&
                                subdepartment.value.contract_total != undefined
                              ">
                              {{
                                getPercentage(subdepartment.value.department_id, subdepartment.value.contract_total)
                                  | number: '1.0-1'
                              }}%
                            </td>
                            <td
                              width="120"
                              *ngIf="
                                subdepartment.value.contract_total == '' ||
                                subdepartment.value.contract_total == null ||
                                subdepartment.value.contract_total == 0 ||
                                subdepartment.value.contract_total == undefined
                              ">
                              0%
                            </td>
                            <td width="120">
                              {{
                                getTotalOfDepartment('estimated_hours', subdepartment.value.department_id)
                                  | number: '1.0-2'
                              }}
                            </td>
                            <td width="120">
                              {{
                                getTotalOfDepartment('prod_units', subdepartment.value.department_id) | number: '1.0-2'
                              }}
                            </td>
                          </tr>
                        </tbody>
                        <tfoot class="font-weight-bold">
                          <tr>
                            <td>Project Total</td>
                            <td>$ {{ getProjectTotal('contract_total') | number: '1.2-2' }}</td>
                            <td>$ {{ getProjectTotal('estimated_cost') | number: '1.2-2' }}</td>
                            <td>$ {{ getProjectTotal('estimated_profit') | number: '1.2-2' }}</td>
                            <td>{{ getProjectTotal('estimated_gm') | number: '1.0-0' }}%</td>
                            <td>{{ getProjectTotal('estimated_hours') | number: '1.0-2' }}</td>
                            <td>{{ getProjectTotal('prod_units') | number: '1.0-2' }}</td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12 col-sm-12 col-md-12 col-lg-7">
              <div class="card">
                <div class="card-header font-weight-bold">Cost Codes</div>
                <fieldset
                  [disabled]="
                    (permissionMap?.financials?.view && !permissionMap?.financials?.edit) || isDeleted || disableSave
                  ">
                  <div class="card-body p-0" *ngIf="jobDetailForm && jobDetailForm.get('department')">
                    <div
                      class="item border-bottom pb-5 pt-3 pl-3 pr-3"
                      *ngFor="
                        let item of jobDetailForm.get('department')['controls'][0].controls.sub_department.value;
                        let k = index
                      ">
                      <div class="row" *ngIf="!isDepartmentCostCodeExist(item.department_id)">
                        <div class="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4">
                          <span class="font-14 text-gray">Job #</span>
                          <p class="text-black">{{ item.number }}</p>
                        </div>
                        <div class="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                          <span class="font-14 text-gray">Department</span>
                          <p class="text-black">{{ item.department_short_code }} - {{ item.department_name }}</p>
                        </div>
                      </div>
                      <div
                        class="row justify-content-between align-items-center"
                        *ngIf="isDepartmentCostCodeExist(item.department_id)">
                        <div class="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                          <span class="font-14 text-gray">Job #</span>
                          <p class="text-black">{{ item.number }}</p>
                        </div>
                        <div class="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                          <span class="font-14 text-gray">Department</span>
                          <p class="text-black">{{ item.department_short_code }} - {{ item.department_name }}</p>
                        </div>
                        <div class="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-3 text-right">
                          <a
                            href="javascript:;"
                            data-toggle="modal"
                            data-target="#task-code"
                            class="btn btn-sm btn-outline-primary"
                            (click)="getDefaultCostCodeData(item.department_id, item.id)"
                            tabindex="{{ 320 + k * 100 }}"
                            >Edit</a
                          >
                        </div>
                      </div>
                      <a
                        href="javascript:;"
                        data-toggle="modal"
                        data-target="#task-code"
                        class="btn btn-sm btn-outline-primary"
                        (click)="getDefaultCostCodeData(item.department_id, item.id)"
                        ng-disabled="(permissionMap?.financials?.view && !permissionMap?.financials?.edit) || disableSave"
                        *ngIf="!isDepartmentCostCodeExist(item.department_id)"
                        tabindex="{{ 320 + k * 100 }}"
                        >Select Cost Code</a
                      >
                      <div class="table-responsive" *ngIf="isDepartmentCostCodeExist(item.department_id)">
                        <form [formGroup]="jobDepartmentCostCodeDetailForm">
                          <div formArrayName="jobDepartmentCostCode_{{ item.department_id }}">
                            <div
                              *ngFor="
                                let ctrl of jobDepartmentCostCodeDetailForm.get(
                                  'jobDepartmentCostCode_' + item.department_id
                                )['controls'];
                                let i = index
                              "
                              [formGroupName]="i">
                              <table class="table m-0">
                                <thead>
                                  <tr>
                                    <th class="border-bottom">Cost Code</th>
                                    <th class="border-bottom"></th>
                                    <th class="border-bottom">Estimated Cost</th>
                                    <th class="border-bottom">Est. Hours</th>
                                    <th class="border-bottom">Prod Units</th>
                                  </tr>
                                </thead>
                                <tbody
                                  formArrayName="indi_costcode"
                                  [attr.disabled]="
                                    (permissionMap?.financials?.view && !permissionMap?.financials?.edit) || disableSave
                                  ">
                                  <!-- <fieldset
                                  [disabled]="permissionMap?.financials?.view && !permissionMap?.financials?.edit"> -->
                                  <tr
                                    *ngFor="let costcode of ctrl.get('indi_costcode')['controls']; let j = index"
                                    [formGroupName]="j"
                                    class="costcode_{{ i }}">
                                    <td class="border-top-0">
                                      {{ costcode.value.pos1 }} - {{ costcode.value.pos2 }} -
                                      {{ costcode.value.pos3 }} - {{ costcode.value.pos4 }}
                                    </td>
                                    <td class="border-top-0">{{ costcode.value.description }}</td>
                                    <td class="border-top-0" width="180">
                                      <input
                                        type="text"
                                        name=""
                                        class="form-control form-control-sm text-right"
                                        tabindex="{{ 320 + 3 * j + 1 + k * 100 }}"
                                        formControlName="estimated_cost"
                                        mask="separator"
                                        thousandSeparator=","
                                        #costcodeinput
                                        [prefix]="setPrefix(j, item.department_id)"
                                        (keyup)="
                                          setCostCodeDataToControl(costcode, 'estimated_cost', costcodeinput.value)
                                        " />
                                    </td>
                                    <td class="border-top-0" width="130">
                                      <input
                                        type="text"
                                        name=""
                                        class="form-control form-control-sm text-right"
                                        tabindex="{{ 320 + 3 * j + 2 + k * 100 }}"
                                        formControlName="estimated_hours"
                                        mask="separator"
                                        thousandSeparator="," />
                                    </td>
                                    <td class="border-top-0" width="130">
                                      <input
                                        type="text"
                                        name=""
                                        class="form-control form-control-sm text-right"
                                        tabindex="{{ 320 + 3 * j + 3 + k * 100 }}"
                                        formControlName="prod_units"
                                        mask="separator"
                                        thousandSeparator="," />
                                    </td>
                                  </tr>
                                  <!-- </fieldset> -->
                                </tbody>
                                <tfoot class="font-weight-bold">
                                  <tr>
                                    <td class="border-top-0" colspan="2"></td>
                                    <td class="border-top-0">
                                      $
                                      {{ getTotalOfDepartment('estimated_cost', item.department_id) | number: '1.2-2' }}
                                    </td>
                                    <td class="border-top-0">
                                      {{
                                        getTotalOfDepartment('estimated_hours', item.department_id) | number: '1.0-2'
                                      }}
                                    </td>
                                    <td class="border-top-0">
                                      {{ getTotalOfDepartment('prod_units', item.department_id) | number: '1.0-2' }}
                                    </td>
                                  </tr>
                                </tfoot>
                              </table>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-5">
              <div class="card mt-3 mt-lg-0">
                <div class="card-header font-weight-bold">Notes</div>
                <div class="card-body">
                  <div class="form-group">
                    <fieldset
                      [disabled]="
                        (permissionMap?.financials?.view && !permissionMap?.financials?.edit) ||
                        isDeleted ||
                        disableSave
                      ">
                      <textarea
                        class="form-control"
                        placeholder="Notes"
                        rows="4"
                        formControlName="financial_notes"
                        tabindex="1521"></textarea>
                    </fieldset>
                  </div>
                </div>
              </div>
              <div class="card mt-3">
                <div class="card-header font-weight-bold">Attachments</div>
                <div class="card-body">
                  <div class="form-group">
                    <label>Other Attachments</label>
                    <div class="custom-file">
                      <input
                        type="hidden"
                        class="custom-file-input"
                        id="financial-other-documents"
                        formControlName="financial_attach_other_document"
                        #financial_attach_other_document
                        (change)="onFileSelect($event, 'financial_attach_other_document')"
                        multiple />
                      <label
                        class="custom-file-label"
                        for="financial-other-documents"
                        data-browse="Upload file..."
                        data-toggle="modal"
                        data-target="#file-upload"
                        (click)="setFileUploadSection('financial_attach_other_document')"></label>
                    </div>
                    <div *ngIf="fileList['financial_attach_other_document'].length > 0">
                      <span *ngFor="let file of fileList['financial_attach_other_document_filenames']; let i = index"
                        ><a href="{{ fileList['financial_attach_other_document'][i] }}" target="_blank">{{
                          extractFileString(file)
                        }}</a
                        ><i
                          class="fal fa-times pl-2"
                          (click)="removeFile(i, 'financial_attach_other_document', file)"
                          *ngIf="file && fileList['financial_attach_other_document_media_ids'][i]"></i
                        ><br />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Financials End -->
        <!-- Documents -->
        <div class="tab-pane fade" id="documents" role="tabpanel"></div>
        <!-- Documents End -->
        <div *ngIf="userPermissions?.audit_trail?.view" class="tab-pane fade" id="audit-trail" role="tabpanel">
          <div class="table-responsive">
            <table class="table audit-trail-data-table mt-0 audit-trail">
              <thead>
                <tr>
                  <th>TIME STAMP</th>
                  <th>USER DETAILS</th>
                  <th>IP ADDRESS</th>
                  <th>ACTION</th>
                  <th>MESSAGE</th>
                  <th width="300">STATUS UPDATE</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of auditTrailData">
                  <td>{{ getAuditTime(item.created_date) }}</td>
                  <td>{{ item.user_name }}</td>
                  <td>{{ item.ip_address }}</td>
                  <td>
                    <!-- ACTION column -->
                    <ng-container
                      *ngIf="(permissionMap?.audit_trail?.view && !permissionMap?.audit_trail?.edit) || isDeleted">
                      <a href="javascript:;" class="act-btn success" *ngIf="item.action == 1"
                        ><i class="fas fa-plus-circle"></i> Add</a
                      >
                      <a href="javascript:;" class="act-btn info" *ngIf="item.action == 2"
                        ><i class="fas fa-edit"></i> Edit</a
                      >
                      <a href="javascript:;" class="act-btn danger" *ngIf="item.action == 3"
                        ><i class="fas fa-do-not-enter"></i> Delete</a
                      >
                    </ng-container>
                  </td>
                  <td>
                    <!-- MESSAGE column -->
                    <div *ngIf="item.action == 3">Updated invoice status</div>
                    <ng-container *ngIf="item.action != 3">
                      <div *ngIf="item.status_to != 0">
                        {{
                          item.status_to == 2
                            ? 'Job was added'
                            : item.status_to == 3
                              ? 'Job was synced from Sage'
                              : item.status_to == 4
                                ? 'Job was deleted'
                                : item.status_to == 5
                                  ? 'Job was marked as closed'
                                  : item.status_to == 6
                                    ? 'Job details were edited'
                                    : item.status_to == 7
                                      ? 'The locked fields were updated in General Info and B&A tab'
                                      : item.status_to == 8
                                        ? item.description
                                        : ''
                        }}
                      </div>
                      <div
                        *ngIf="
                          (item.working_status_from == 0 && item.working_status_to != 0) ||
                          (item.working_status_from != 0 && item.working_status_to != 0)
                        ">
                        {{
                          item.working_status_to == 1
                            ? 'Job was pulled'
                            : 'Job working status changed to ' + getWorkingStatusText(item.working_status_to)
                        }}
                      </div>
                      <div *ngIf="item.working_status_to == 0 && item.working_status_from != 0">
                        {{
                          item.action == 1
                            ? 'Job details were exported for Sage'
                            : 'Job details were submitted to the accounting'
                        }}
                      </div>
                    </ng-container>
                  </td>
                  <td *ngIf="item.status_to < 9" style="width: 25%">
                    <!-- WORKING STATUS column -->
                    <ng-container *ngIf="item.action == 3">
                      <div>
                        <span
                          [class]="
                            'audit-invoice-status audit-invoice-status_' +
                            getCssClassName(invoiceStatusDescription[item.status_from])
                          ">
                          {{ invoiceStatusDescription[item.status_from] }}
                        </span>
                        <i class="fas fa-arrow-right"></i>
                        <span
                          [class]="
                            'audit-invoice-status audit-invoice-status_' +
                            getCssClassName(invoiceStatusDescription[item.status_to])
                          ">
                          {{ invoiceStatusDescription[item.status_to] }}
                        </span>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="item.action != 3">
                      <div *ngIf="item.status_from != 0 && item.status_to != 0">
                        <button type="button" class="btn btn-light font-weight-bold" *ngIf="item.status_from == 1">
                          Created
                        </button>
                        <button type="button" class="btn btn-info font-weight-bold" *ngIf="item.status_from == 2">
                          Started
                        </button>
                        <button type="button" class="btn btn-success font-weight-bold" *ngIf="item.status_from == 3">
                          Active
                        </button>
                        <button type="button" class="btn btn-danger font-weight-bold" *ngIf="item.status_from == 4">
                          Deleted
                        </button>
                        <button type="button" class="btn btn-dark-100 font-weight-bold" *ngIf="item.status_from == 5">
                          Closed
                        </button>
                        <button type="button" class="btn text-black pl-1 pr-1">
                          <i class="fas fa-arrow-right"></i>
                        </button>
                        <button type="button" class="btn btn-info font-weight-bold" *ngIf="item.status_to == 2">
                          Started
                        </button>
                        <button type="button" class="btn btn-success font-weight-bold" *ngIf="item.status_to == 3">
                          Active
                        </button>
                        <button type="button" class="btn btn-danger font-weight-bold" *ngIf="item.status_to == 4">
                          Deleted
                        </button>
                        <button type="button" class="btn btn-dark-100 font-weight-bold" *ngIf="item.status_to == 5">
                          Closed
                        </button>
                      </div>
                      <div *ngIf="item.status_to == 6 || item.status_to == 8" class="text-center font-weight-bold">
                        <label>No change</label>
                      </div>
                      <div *ngIf="item.status_to == 7" class="text-center font-weight-bold">
                        <label>Locked Field Change</label>
                      </div>
                      <div
                        *ngIf="
                          (item.working_status_from == 0 && item.working_status_to != 0) ||
                          (item.working_status_from != 0 && item.working_status_to != 0)
                        ">
                        <button
                          type="button"
                          class="btn btn-light font-weight-bold"
                          *ngIf="jobDetail && getWorkingStatusText(item.working_status_from) == 'Created'">
                          {{ getWorkingStatusText(item.working_status_from) }}
                        </button>
                        <button
                          type="button"
                          class="btn btn-dark font-weight-bold"
                          *ngIf="jobDetail && getWorkingStatusText(item.working_status_from) != 'Created'">
                          {{ getWorkingStatusText(item.working_status_from) }}
                        </button>
                        <button type="button" class="btn text-black pl-1 pr-1" *ngIf="jobDetail">
                          <i class="fas fa-arrow-right"></i>
                        </button>
                        <button type="button" class="btn btn-dark font-weight-bold" *ngIf="jobDetail">
                          {{ getWorkingStatusText(item.working_status_to) }}
                        </button>
                      </div>
                      <div
                        *ngIf="item.working_status_to == 0 && item.working_status_from != 0"
                        class="text-center font-weight-bold">
                        <label>No change</label>
                      </div>
                    </ng-container>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </form>
  </div>
  <!-- Project Tabs End-->
</div>

<!-- Select Cost Code Modal -->
<div
  class="modal fade"
  id="task-code"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
  *ngIf="jobDetailForm && jobDetailForm.get('department')">
  <div class="modal-dialog modal-xl">
    <div
      class="modal-content pb-0"
      *ngFor="let item of jobDetailForm.get('department')['controls'][0].controls.sub_department.value">
      <div *ngIf="item.department_id == lastJobCostCodeDeparrmentSelection">
        <form [formGroup]="jobDepartmentCustomCostCodeDetailForm">
          <fieldset
            [disabled]="
              (permissionMap?.financials?.view && !permissionMap?.financials?.edit) || isDeleted || disableSave
            ">
            <div class="modal-header bg-color">
              <h5 class="modal-title">{{ item.department_name }} Template</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true"><i class="fal fa-times"></i></span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div *ngIf="!costCodesLoaded" class="col-sm-12 text-center">Loading cost code template...</div>
                <ng-container *ngIf="costCodesLoaded">
                  <div
                    class="col-12 col-12 col-md-12 col-lg-4"
                    *ngFor="let item of jobDefaultCostCodeData; let i = index">
                    <div class="mb-4" *ngFor="let itemData of item; let j = index">
                      <h6 class="font-14 font-weight-bold mb-3">{{ itemData[0].name }}</h6>
                      <div class="custom-control custom-checkbox" *ngFor="let itemDetail of itemData; let k = index">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="chk_{{ itemDetail.department_id }}_{{ itemDetail.id }}"
                          (change)="setSelectedTaskCodes($event, itemDetail)"
                          [checked]="getCheckedStatus(itemDetail.department_id, itemDetail)" />
                        <label class="custom-control-label" for="chk_{{ itemDetail.department_id }}_{{ itemDetail.id }}"
                          >{{ itemDetail.pos1 }} - {{ itemDetail.pos2 }} - {{ itemDetail.pos3 }} -
                          {{ itemDetail.pos4 }} &nbsp;&nbsp; {{ itemDetail.description }}</label
                        >
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
              <hr />
              <div class="custom-task">
                <h6 class="font-14 font-weight-bold mb-3">Custom Cost Codes</h6>
                <div formArrayName="{{ checkGenerateCustomCostCodeForm(item.department_id) }}">
                  <div
                    *ngFor="
                      let ctrl of jobDepartmentCustomCostCodeDetailForm.get(
                        'jobDepartmentCustomCostCode_' + item.department_id
                      )['controls'];
                      let i = index
                    "
                    [formGroupName]="i">
                    <div formArrayName="indi_costcode">
                      <div
                        *ngFor="let costcode of ctrl.get('indi_costcode')['controls']; let j = index"
                        [formGroupName]="j"
                        class="costcode_{{ i }}">
                        <div class="row no-gutters">
                          <div class="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-3">
                            <div class="d-flex justify-content-center align-items-center">
                              <input
                                type="text"
                                name=""
                                class="form-control text-center"
                                maxlength="1"
                                placeholder="-"
                                formControlName="pos1"
                                id="pos1_{{ item.department_id }}_{{ j }}"
                                [value]="costcode.value.pos1 | uppercase"
                                (input)="costcode.value.pos1 = costcode.value.pos1.toUpperCase()" />
                              <span class="ml-1 mr-1 d-inline"> - </span>
                              <input
                                type="text"
                                name=""
                                class="form-control text-center"
                                maxlength="2"
                                placeholder="- -"
                                formControlName="pos2"
                                id="pos2_{{ item.department_id }}_{{ j }}"
                                [value]="costcode.value.pos2 | uppercase"
                                (input)="costcode.value.pos2 = costcode.value.pos2.toUpperCase()" />
                              <span class="ml-1 mr-1 d-inline"> - </span>
                              <input
                                type="text"
                                name=""
                                class="form-control text-center"
                                maxlength="2"
                                placeholder="- -"
                                formControlName="pos3"
                                id="pos3_{{ item.department_id }}_{{ j }}"
                                [value]="costcode.value.pos3 | uppercase"
                                (input)="costcode.value.pos3 = costcode.value.pos3.toUpperCase()" />
                              <span class="ml-1 mr-1 d-inline"> - </span>
                              <input
                                type="text"
                                name=""
                                class="form-control text-center"
                                maxlength="4"
                                placeholder="- - - -"
                                style="width: 70px"
                                formControlName="pos4"
                                id="pos4_{{ item.department_id }}_{{ j }}"
                                [value]="costcode.value.pos4 | uppercase"
                                (input)="costcode.value.pos4 = costcode.value.pos4.toUpperCase()" />
                              <span class="ml-1 mr-1 d-none d-lg-block"> - </span>
                            </div>
                          </div>
                          <div class="col-10 col-sm-10 col-md-10 col-lg-5">
                            <div class="form-group mt-3 mt-lg-0">
                              <input
                                type="text"
                                class="form-control"
                                name=""
                                placeholder="Description"
                                formControlName="description"
                                id="description_{{ item.department_id }}_{{ j }}" />
                            </div>
                          </div>
                          <div class="col-2 col-sm-2 col-md-2 col-lg-2">
                            <a
                              href="javascript:;"
                              class="remove mt-3 mt-lg-0"
                              (blur)="checkToAddNewCostCode(j, ctrl.get('indi_costcode'))"
                              (click)="deleteCustomCostCode(costcode.value, j)"
                              ><i class="far fa-times-circle"></i
                            ></a>
                          </div>
                          <div id="duplicate_error_{{ item.department_id }}_{{ j }}" class="hide error mb-2">
                            Duplicate cost code. Please add a unique cost code.
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="add-fild">
                      <a
                        href="javascript:;"
                        class="text-pink"
                        (click)="addAdditionalCustomCostCodeInfoSameEditTime(ctrl.get('indi_costcode'))"
                        >+ Add New Cost Code</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer justify-content-center">
              <button type="button" class="btn btn-outline-primary width-fix" #costCodeCloseBtn data-dismiss="modal">
                Cancel
              </button>
              <button
                type="submit"
                [disabled]="(permissionMap?.financials?.view && !permissionMap?.financials?.edit) || disableSave"
                class="btn btn-primary width-fix"
                (click)="submitJobCostCodes()">
                Save and Close
              </button>
            </div>
          </fieldset>
        </form>
      </div>
    </div>
  </div>
</div>
<!-- Select Cost Code Modal End-->

<!-- Remove Department Modal -->
<div class="modal fade" id="remove-department" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content pb-0">
      <form action="#">
        <div class="modal-header border-0">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="redoSelection()">
            <span aria-hidden="true"><i class="fal fa-times"></i></span>
          </button>
        </div>
        <div class="modal-body pb-0 pt-0">
          <div class="notification-text text-center">
            <h4 class="font-weight-normal">
              Are you sure you want to remove this department from this job? <br />
              You will lose all the general, financial, and contract details for this department
            </h4>
          </div>
        </div>
        <div class="modal-footer justify-content-center border-0">
          <button
            type="button"
            class="btn btn-outline-primary width-fix"
            data-dismiss="modal"
            (click)="redoSelection()"
            #departmentCloseBtn>
            Cancel
          </button>
          <button type="submit" class="btn btn-primary width-fix" (click)="removeDepartment()">
            Remove Department
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- Remove Department Modal End-->

<!-- Remove Main Job Alert Modal -->
<div class="modal fade" id="remove-department-alert" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content pb-0">
      <form action="#">
        <div class="modal-header border-0">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="redoSelection()">
            <span aria-hidden="true"><i class="fal fa-times"></i></span>
          </button>
        </div>
        <div class="modal-body pb-0 pt-0">
          <div class="notification-text text-center">
            <h4 class="font-weight-normal">
              You are trying to remove the only department for this Job. At least one department is required.
            </h4>
          </div>
        </div>
        <div class="modal-footer justify-content-center border-0">
          <button
            type="button"
            class="btn btn-outline-primary width-fix"
            data-dismiss="modal"
            (click)="redoSelection()"
            #departmentAlertCloseBtn>
            Cancel
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- Remove Main Job Alert Modal End-->
<a
  href="javascript:;"
  class="text-blue"
  data-toggle="modal"
  data-target="#remove-department-alert"
  #removeDepartmentAlert></a>
<!-- <div style="width: 0 !important;  height: 0 !important; overflow: hidden !important;"> -->
<a
  href="javascript:;"
  class="text-blue"
  data-toggle="modal"
  data-target="#confirm-submit-to-accounting"
  #showSubmitToAccountingModal></a>
<!-- </div> -->

<!-- Submit to accounting confirmation Modal -->
<div class="modal fade" id="confirm-submit-to-accounting" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content pb-0">
      <form action="#">
        <div class="modal-header border-0">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true"><i class="fal fa-times"></i></span>
          </button>
        </div>
        <div class="modal-body pb-0 pt-0">
          <div class="notification-text text-center">
            <h4 class="font-weight-normal">
              Would you like to submit this job to accounting with required fields missing?
            </h4>
          </div>
        </div>
        <div class="modal-footer justify-content-center border-0">
          <button
            type="button"
            class="btn btn-outline-primary width-fix"
            #closeSubmitToAccountingButton
            data-dismiss="modal">
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-primary width-fix"
            (click)="saveJobDetails(jobDetailForm, false, true, false)"
            data-dismiss="modal">
            Yes
          </button>
          <span class="pt-10 text-center"
            >Remember to save any changes you make to the required fields, before trying Submit to Accounting
            again.</span
          >
        </div>
      </form>
    </div>
  </div>
</div>
<!-- Submit to accounting confirmation Modal End-->

<!-- File Upload Modal -->
<div class="modal fade" id="file-upload" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content pb-0">
      <div class="modal-header border-0">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"><i class="fal fa-times"></i></span>
        </button>
      </div>
      <div>
        <div
          class="dropzone"
          dropzone
          (hovered)="toggleHover($event)"
          (dropped)="onDrop($event)"
          [class.hovering]="isHovering">
          <i class="fal fa-cloud-upload fa-4x"></i>
          <p>Drag and Drop a File</p>
          <div class="file">
            <label class="file-label">
              <input class="file-input" type="file" (change)="onDrop($event.target.files)" multiple id="dropZoneFile" />
            </label>
          </div>
        </div>

        <div *ngFor="let file of attachSchedulefiles; let i = index" class="listCenter">
          <div>{{ file.name }}<i class="fal fa-times pl-2" (click)="removeAttachment(i)"></i></div>
          <div *ngIf="snapshot | async as snap">
            <div *ngIf="downloadURL as url"><img [src]="url" height="20px" width="20px" /><br /></div>

            <button (click)="task.cancel()" [disabled]="!isActive(snap)">Cancel</button>
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-center border-0">
        <button type="button" class="btn btn-outline-primary width-fix" data-dismiss="modal" #fileUploadCloseBtn>
          Cancel
        </button>
        <button type="submit" class="btn btn-primary width-fix" (click)="uploadFiles()">Upload</button>
      </div>
    </div>
  </div>
</div>
<!-- File Upload Modal End-->

<div class="hide" *ngIf="detailDataLoaded" id="sageExportDiv">
  <table class="table border-0" id="htmlData1">
    <tbody>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Job Number</td>
        <td style="width: 20%">{{ jobDetail.number }}</td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Departments</td>
        <td style="width: 20%">{{ getSubDepartment('0', 'department_name') }}</td>
        <td style="width: 20%">{{ getSubDepartment('1', 'department_name') }}</td>
        <td style="width: 20%">{{ getSubDepartment('2', 'department_name') }}</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Job Name</td>
        <td style="width: 20%">{{ jobDetail.name }}</td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Jobsite Address</td>
        <td style="width: 20%">{{ getFormDetail('address1') }}</td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Jobsite City</td>
        <td style="width: 20%">{{ getFormDetail('city') }}</td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Jobsite State</td>
        <td style="width: 20%">
          {{ getFormArrayDetail(statesData, 'id', getFormDetail('state_id'), 'abbreviation') }}
        </td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Jobsite Zip Code</td>
        <td style="width: 20%">{{ getFormDetail('postal_code') }}</td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Union Local #</td>
        <td style="width: 20%">
          {{ getFormArrayDetail(unionLocalsData, 'id', getFormDetail('labor_union_local_id'), 'union_local_id') }}
        </td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Contract Size</td>
        <td style="width: 20%">
          {{
            jobDetail.contract_size == 1
              ? '$0 - $10,000'
              : jobDetail.contract_size == 2
                ? '$10,000 - $100,000'
                : jobDetail.contract_size == 3
                  ? '$100,000 or Greater'
                  : '-'
          }}
        </td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Main Project Manager</td>
        <td style="width: 20%">{{ getSubDepartment('0', 'project_manager_id') }}</td>
        <td style="width: 20%">{{ getSubDepartment('1', 'project_manager_id') }}</td>
        <td style="width: 20%">{{ getSubDepartment('2', 'project_manager_id') }}</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Estimator</td>
        <td style="width: 20%">{{ getSubDepartment('0', 'estimator_id') }}</td>
        <td style="width: 20%">{{ getSubDepartment('1', 'estimator_id') }}</td>
        <td style="width: 20%">{{ getSubDepartment('2', 'estimator_id') }}</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Foreman</td>
        <td style="width: 20%">{{ getSubDepartment('0', 'foreman_id') }}</td>
        <td style="width: 20%">{{ getSubDepartment('1', 'foreman_id') }}</td>
        <td style="width: 20%">{{ getSubDepartment('2', 'foreman_id') }}</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Job Location</td>
        <td style="width: 20%">
          {{ getFormArrayDetail(ownersFacilityData, 'id', getFormDetail('facility_location_id'), 'facility_name') }}
        </td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Owner</td>
        <td style="width: 20%">{{ getFormArrayDetail(ownersData, 'id', getFormDetail('owner_id'), 'owner_name') }}</td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Purchase Order/Contract #</td>
        <td style="width: 20%">{{ getFormDetail('contact_purchse_order') }}</td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Assistant</td>
        <td style="width: 20%">{{ getSubDepartment('0', 'assistant_id') }}</td>
        <td style="width: 20%">{{ getSubDepartment('1', 'assistant_id') }}</td>
        <td style="width: 20%">{{ getSubDepartment('2', 'assistant_id') }}</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px"></td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Job Creation Date</td>
        <td style="width: 20%">{{ jobCreationData }}</td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">T&M</td>
        <td style="width: 20%">
          {{ getFormDetail('contact_tm') == 1 ? 'Yes' : 'No' }}
        </td>

        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Pre Con</td>
        <td style="width: 20%">
          {{ getFormDetail('is_precon_involved') == 1 ? 'Yes' : 'No' }}
        </td>

        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Turnover Complete</td>
        <td style="width: 20%">
          {{ getFormDetail('turnover_complete') == 1 ? 'Yes' : 'No' }}
        </td>

        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">OCIP</td>
        <td style="width: 20%">
          {{ getFormDetail('additional_ocip') == 1 ? 'Yes' : 'No' }}
        </td>

        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Prevailing Wage</td>
        <td style="width: 20%">
          {{ getFormDetail('labor_prevailing_wage') == 1 ? 'Yes' : 'No' }}
        </td>

        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Union Targeting</td>
        <td style="width: 20%">
          {{ getFormDetail('additional_union_targeting') == 1 ? 'Yes' : 'No' }}
        </td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">AR Customer ID</td>
        <td style="width: 20%">{{ getFormDetail('contact_ar_customer_id') }}</td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Billing Type(Quick, Contract, AIA)</td>
        <td style="width: 20%">
          {{
            getFormDetail('contact_type_of_billing') == 1
              ? 'Quick Bill'
              : getFormDetail('contact_type_of_billing') == 2
                ? 'Contract'
                : 'AIA'
          }}
        </td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px"></td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Scope of Work</td>
        <td style="width: 20%">{{ jobDetail.description }}</td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px"></td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Certified Payroll Y/N</td>
        <td style="width: 20%">
          {{ getFormDetail('labor_certified_payroll') == 1 ? 'Yes' : 'No' }}
        </td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Local WH</td>
        <td style="width: 20%">{{ getFormDetail('code') }}</td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Tax Status</td>
        <td style="width: 20%">
          {{ getFormArrayDetail(taxStatusData, 'id', getFormDetail('sales_tax_status_id'), 'name') }}
        </td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px"></td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Project Type</td>
        <td style="width: 20%">
          {{ getFormArrayDetail(projectTypeData, 'id', getFormDetail('project_type_id'), 'name') }}
        </td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Project Industry</td>
        <td style="width: 20%">
          {{ getFormArrayDetail(projectIndustryData, 'id', getFormDetail('project_industry_id'), 'name') }}
        </td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Contract Total</td>
        <td style="width: 20%">$ {{ getProjectTotal('contract_total') | number: '1.2-2' }}</td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Estimated Cost</td>
        <td style="width: 20%">$ {{ getProjectTotal('estimated_cost') | number: '1.2-2' }}</td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
    </tbody>
  </table>
  <table class="table border-0" id="htmlData2" #htmlData>
    <tbody>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Job Number</td>
        <td style="width: 20%">{{ jobDetail.number }}</td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Departments</td>
        <td style="width: 20%">{{ getSubDepartment('0', 'department_name') }}</td>
        <td style="width: 20%">{{ getSubDepartment('1', 'department_name') }}</td>
        <td style="width: 20%">{{ getSubDepartment('2', 'department_name') }}</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Job Name</td>
        <td style="width: 20%">{{ jobDetail.name }}</td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Jobsite Address</td>
        <td style="width: 20%">{{ getFormDetail('address1') }}</td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Jobsite City</td>
        <td style="width: 20%">{{ getFormDetail('city') }}</td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Jobsite State</td>
        <td style="width: 20%">
          {{ getFormArrayDetail(statesData, 'id', getFormDetail('state_id'), 'abbreviation') }}
        </td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Jobsite Zip Code</td>
        <td style="width: 20%">{{ getFormDetail('postal_code') }}</td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Union Local #</td>
        <td style="width: 20%">
          {{ getFormArrayDetail(unionLocalsData, 'id', getFormDetail('labor_union_local_id'), 'union_local_id') }}
        </td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Contract Size</td>
        <td style="width: 20%">
          {{
            jobDetail.contract_size == 1
              ? '$0 - $10,000'
              : jobDetail.contract_size == 2
                ? '$10,000 - $100,000'
                : jobDetail.contract_size == 3
                  ? '$100,000 or Greater'
                  : '-'
          }}
        </td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Main Project Manager</td>
        <td style="width: 20%">{{ getSubDepartment('0', 'project_manager_id') }}</td>
        <td style="width: 20%">{{ getSubDepartment('1', 'project_manager_id') }}</td>
        <td style="width: 20%">{{ getSubDepartment('2', 'project_manager_id') }}</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Estimator</td>
        <td style="width: 20%">{{ getSubDepartment('0', 'estimator_id') }}</td>
        <td style="width: 20%">{{ getSubDepartment('1', 'estimator_id') }}</td>
        <td style="width: 20%">{{ getSubDepartment('2', 'estimator_id') }}</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Foreman</td>
        <td style="width: 20%">{{ getSubDepartment('0', 'foreman_id') }}</td>
        <td style="width: 20%">{{ getSubDepartment('1', 'foreman_id') }}</td>
        <td style="width: 20%">{{ getSubDepartment('2', 'foreman_id') }}</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Job Location</td>
        <td style="width: 20%">
          {{ getFormArrayDetail(ownersFacilityData, 'id', getFormDetail('facility_location_id'), 'facility_name') }}
        </td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Owner</td>
        <td style="width: 20%">{{ getFormArrayDetail(ownersData, 'id', getFormDetail('owner_id'), 'owner_name') }}</td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Purchase Order/Contract #</td>
        <td style="width: 20%">{{ getFormDetail('contact_purchse_order') }}</td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Assistant</td>
        <td style="width: 20%">{{ getSubDepartment('0', 'assistant_id') }}</td>
        <td style="width: 20%">{{ getSubDepartment('1', 'assistant_id') }}</td>
        <td style="width: 20%">{{ getSubDepartment('2', 'assistant_id') }}</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px"></td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Job Creation Date</td>
        <td style="width: 20%">{{ jobCreationData }}</td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">T&M</td>
        <td style="width: 20%">
          {{ getFormDetail('contact_tm') == 1 ? 'Yes' : 'No' }}
        </td>

        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Pre Con</td>
        <td style="width: 20%">
          {{ getFormDetail('is_precon_involved') == 1 ? 'Yes' : 'No' }}
        </td>

        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Turnover Complete</td>
        <td style="width: 20%">
          {{ getFormDetail('turnover_complete') == 1 ? 'Yes' : 'No' }}
        </td>

        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">OCIP</td>
        <td style="width: 20%">
          {{ getFormDetail('additional_ocip') == 1 ? 'Yes' : 'No' }}
        </td>

        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Prevailing Wage</td>
        <td style="width: 20%">
          {{ getFormDetail('labor_prevailing_wage') == 1 ? 'Yes' : 'No' }}
        </td>

        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Union Targeting</td>
        <td style="width: 20%">
          {{ getFormDetail('additional_union_targeting') == 1 ? 'Yes' : 'No' }}
        </td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">AR Customer ID</td>
        <td style="width: 20%">{{ getFormDetail('contact_ar_customer_id') }}</td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Billing Type(Quick, Contract, AIA)</td>
        <td style="width: 20%">
          {{
            getFormDetail('contact_type_of_billing') == 1
              ? 'Quick Bill'
              : getFormDetail('contact_type_of_billing') == 2
                ? 'Contract'
                : 'AIA'
          }}
        </td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px"></td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Scope of Work</td>
        <td style="width: 20%">{{ jobDetail.description }}</td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px"></td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Certified Payroll Y/N</td>
        <td style="width: 20%">
          {{ getFormDetail('labor_certified_payroll') == 1 ? 'Yes' : 'No' }}
        </td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Local WH</td>
        <td style="width: 20%">{{ getFormDetail('code') }}</td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Tax Status</td>
        <td style="width: 20%">
          {{ getFormArrayDetail(taxStatusData, 'id', getFormDetail('sales_tax_status_id'), 'name') }}
        </td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px"></td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Project Type</td>
        <td style="width: 20%">
          {{ getFormArrayDetail(projectTypeData, 'id', getFormDetail('project_type_id'), 'name') }}
        </td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Project Industry</td>
        <td style="width: 20%">
          {{ getFormArrayDetail(projectIndustryData, 'id', getFormDetail('project_industry_id'), 'name') }}
        </td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Contract Total</td>
        <td style="width: 20%">$ {{ getProjectTotal('contract_total') | number: '1.2-2' }}</td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Estimated Cost</td>
        <td style="width: 20%">$ {{ getProjectTotal('estimated_cost') | number: '1.2-2' }}</td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
    </tbody>
  </table>
  <table
    class="table border-0"
    id="htmlData3"
    *ngIf="
      jobDetailForm &&
      jobDetailForm.get('department') &&
      jobDetailForm.get('department')['controls'][0].controls.sub_department.length > 3
    ">
    <tbody>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Job Number</td>
        <td style="width: 20%">{{ jobDetail.number }}</td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Departments</td>
        <td style="width: 20%">{{ getSubDepartment('3', 'department_name') }}</td>
        <td style="width: 20%">{{ getSubDepartment('4', 'department_name') }}</td>
        <td style="width: 20%">{{ getSubDepartment('5', 'department_name') }}</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Job Name</td>
        <td style="width: 20%">{{ jobDetail.name }}</td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Jobsite Address</td>
        <td style="width: 20%">{{ getFormDetail('address1') }}</td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Jobsite City</td>
        <td style="width: 20%">{{ getFormDetail('city') }}</td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Jobsite State</td>
        <td style="width: 20%">
          {{ getFormArrayDetail(statesData, 'id', getFormDetail('state_id'), 'abbreviation') }}
        </td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Jobsite Zip Code</td>
        <td style="width: 20%">{{ getFormDetail('postal_code') }}</td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Union Local #</td>
        <td style="width: 20%">
          {{ getFormArrayDetail(unionLocalsData, 'id', getFormDetail('labor_union_local_id'), 'union_local_id') }}
        </td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Contract Size</td>
        <td style="width: 20%">
          {{
            jobDetail.contract_size == 1
              ? '$0 - $10,000'
              : jobDetail.contract_size == 2
                ? '$10,000 - $100,000'
                : jobDetail.contract_size == 3
                  ? '$100,000 or Greater'
                  : '-'
          }}
        </td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Main Project Manager</td>
        <td style="width: 20%">{{ getSubDepartment('3', 'project_manager_id') }}</td>
        <td style="width: 20%">{{ getSubDepartment('4', 'project_manager_id') }}</td>
        <td style="width: 20%">{{ getSubDepartment('5', 'project_manager_id') }}</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Estimator</td>
        <td style="width: 20%">{{ getSubDepartment('3', 'estimator_id') }}</td>
        <td style="width: 20%">{{ getSubDepartment('4', 'estimator_id') }}</td>
        <td style="width: 20%">{{ getSubDepartment('5', 'estimator_id') }}</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Foreman</td>
        <td style="width: 20%">{{ getSubDepartment('3', 'foreman_id') }}</td>
        <td style="width: 20%">{{ getSubDepartment('4', 'foreman_id') }}</td>
        <td style="width: 20%">{{ getSubDepartment('5', 'foreman_id') }}</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Job Location</td>
        <td style="width: 20%">
          {{ getFormArrayDetail(ownersFacilityData, 'id', getFormDetail('facility_location_id'), 'facility_name') }}
        </td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Owner</td>
        <td style="width: 20%">{{ getFormArrayDetail(ownersData, 'id', getFormDetail('owner_id'), 'owner_name') }}</td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Purchase Order/Contract #</td>
        <td style="width: 20%">{{ getFormDetail('contact_purchse_order') }}</td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Assistant</td>
        <td style="width: 20%">{{ getSubDepartment('3', 'assistant_id') }}</td>
        <td style="width: 20%">{{ getSubDepartment('4', 'assistant_id') }}</td>
        <td style="width: 20%">{{ getSubDepartment('5', 'assistant_id') }}</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px"></td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Job Creation Date</td>
        <td style="width: 20%">{{ jobCreationData }}</td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">T&M</td>
        <td style="width: 20%">
          {{ getFormDetail('contact_tm') == 1 ? 'Yes' : 'No' }}
        </td>

        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Pre Con</td>
        <td style="width: 20%">
          {{ getFormDetail('is_precon_involved') == 1 ? 'Yes' : 'No' }}
        </td>

        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Turnover Complete</td>
        <td style="width: 20%">
          {{ getFormDetail('turnover_complete') == 1 ? 'Yes' : 'No' }}
        </td>

        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">OCIP</td>
        <td style="width: 20%">
          {{ getFormDetail('additional_ocip') == 1 ? 'Yes' : 'No' }}
        </td>

        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Prevailing Wage</td>
        <td style="width: 20%">
          {{ getFormDetail('labor_prevailing_wage') == 1 ? 'Yes' : 'No' }}
        </td>

        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Union Targeting</td>
        <td style="width: 20%">
          {{ getFormDetail('additional_union_targeting') == 1 ? 'Yes' : 'No' }}
        </td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">AR Customer ID</td>
        <td style="width: 20%">{{ getFormDetail('contact_ar_customer_id') }}</td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Billing Type(Quick, Contract, AIA)</td>
        <td style="width: 20%">
          {{
            getFormDetail('contact_type_of_billing') == 1
              ? 'Quick Bill'
              : getFormDetail('contact_type_of_billing') == 2
                ? 'Contract'
                : 'AIA'
          }}
        </td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px"></td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Scope of Work</td>
        <td style="width: 20%">{{ jobDetail.description }}</td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px"></td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Certified Payroll Y/N</td>
        <td style="width: 20%">
          {{ getFormDetail('labor_certified_payroll') == 1 ? 'Yes' : 'No' }}
        </td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Local WH</td>
        <td style="width: 20%">{{ getFormDetail('code') }}</td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Tax Status</td>
        <td style="width: 20%">
          {{ getFormArrayDetail(taxStatusData, 'id', getFormDetail('sales_tax_status_id'), 'name') }}
        </td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px"></td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Project Type</td>
        <td style="width: 20%">
          {{ getFormArrayDetail(projectTypeData, 'id', getFormDetail('project_type_id'), 'name') }}
        </td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Project Industry</td>
        <td style="width: 20%">
          {{ getFormArrayDetail(projectIndustryData, 'id', getFormDetail('project_industry_id'), 'name') }}
        </td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Contract Total</td>
        <td style="width: 20%">$ {{ getProjectTotal('contract_total') | number: '1.2-2' }}</td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Estimated Cost</td>
        <td style="width: 20%">$ {{ getProjectTotal('estimated_cost') | number: '1.2-2' }}</td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
    </tbody>
  </table>
  <table
    class="table border-0"
    id="htmlData4"
    *ngIf="
      jobDetailForm &&
      jobDetailForm.get('department') &&
      jobDetailForm.get('department')['controls'][0].controls.sub_department.length > 6
    ">
    <tbody>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Job Number</td>
        <td style="width: 20%">{{ jobDetail.number }}</td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Departments</td>
        <td style="width: 20%">{{ getSubDepartment('6', 'department_name') }}</td>
        <td style="width: 20%">{{ getSubDepartment('7', 'department_name') }}</td>
        <td style="width: 20%">{{ getSubDepartment('8', 'department_name') }}</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Job Name</td>
        <td style="width: 20%">{{ jobDetail.name }}</td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Jobsite Address</td>
        <td style="width: 20%">{{ getFormDetail('address1') }}</td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Jobsite City</td>
        <td style="width: 20%">{{ getFormDetail('city') }}</td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Jobsite State</td>
        <td style="width: 20%">
          {{ getFormArrayDetail(statesData, 'id', getFormDetail('state_id'), 'abbreviation') }}
        </td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Jobsite Zip Code</td>
        <td style="width: 20%">{{ getFormDetail('postal_code') }}</td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Union Local #</td>
        <td style="width: 20%">
          {{ getFormArrayDetail(unionLocalsData, 'id', getFormDetail('labor_union_local_id'), 'union_local_id') }}
        </td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Contract Size</td>
        <td style="width: 20%">
          {{
            jobDetail.contract_size == 1
              ? '$0 - $10,000'
              : jobDetail.contract_size == 2
                ? '$10,000 - $100,000'
                : jobDetail.contract_size == 3
                  ? '$100,000 or Greater'
                  : '-'
          }}
        </td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Main Project Manager</td>
        <td style="width: 20%">{{ getSubDepartment('6', 'project_manager_id') }}</td>
        <td style="width: 20%">{{ getSubDepartment('7', 'project_manager_id') }}</td>
        <td style="width: 20%">{{ getSubDepartment('8', 'project_manager_id') }}</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Estimator</td>
        <td style="width: 20%">{{ getSubDepartment('6', 'estimator_id') }}</td>
        <td style="width: 20%">{{ getSubDepartment('7', 'estimator_id') }}</td>
        <td style="width: 20%">{{ getSubDepartment('8', 'estimator_id') }}</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Foreman</td>
        <td style="width: 20%">{{ getSubDepartment('6', 'foreman_id') }}</td>
        <td style="width: 20%">{{ getSubDepartment('7', 'foreman_id') }}</td>
        <td style="width: 20%">{{ getSubDepartment('8', 'foreman_id') }}</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Job Location</td>
        <td style="width: 20%">
          {{ getFormArrayDetail(ownersFacilityData, 'id', getFormDetail('facility_location_id'), 'facility_name') }}
        </td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Owner</td>
        <td style="width: 20%">{{ getFormArrayDetail(ownersData, 'id', getFormDetail('owner_id'), 'owner_name') }}</td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Purchase Order/Contract #</td>
        <td style="width: 20%">{{ getFormDetail('contact_purchse_order') }}</td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Assistant</td>
        <td style="width: 20%">{{ getSubDepartment('6', 'assistant_id') }}</td>
        <td style="width: 20%">{{ getSubDepartment('7', 'assistant_id') }}</td>
        <td style="width: 20%">{{ getSubDepartment('8', 'assistant_id') }}</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px"></td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Job Creation Date</td>
        <td style="width: 20%">{{ jobCreationData }}</td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">T&M</td>
        <td style="width: 20%">
          {{ getFormDetail('contact_tm') == 1 ? 'Yes' : 'No' }}
        </td>

        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Pre Con</td>
        <td style="width: 20%">
          {{ getFormDetail('is_precon_involved') == 1 ? 'Yes' : 'No' }}
        </td>

        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Turnover Complete</td>
        <td style="width: 20%">
          {{ getFormDetail('turnover_complete') == 1 ? 'Yes' : 'No' }}
        </td>

        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">OCIP</td>
        <td style="width: 20%">
          {{ getFormDetail('additional_ocip') == 1 ? 'Yes' : 'No' }}
        </td>

        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Prevailing Wage</td>
        <td style="width: 20%">
          {{ getFormDetail('labor_prevailing_wage') == 1 ? 'Yes' : 'No' }}
        </td>

        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Union Targeting</td>
        <td style="width: 20%">
          {{ getFormDetail('additional_union_targeting') == 1 ? 'Yes' : 'No' }}
        </td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">AR Customer ID</td>
        <td style="width: 20%">{{ getFormDetail('contact_ar_customer_id') }}</td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Billing Type(Quick, Contract, AIA)</td>
        <td style="width: 20%">
          {{
            getFormDetail('contact_type_of_billing') == 1
              ? 'Quick Bill'
              : getFormDetail('contact_type_of_billing') == 2
                ? 'Contract'
                : 'AIA'
          }}
        </td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px"></td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Scope of Work</td>
        <td style="width: 20%">{{ jobDetail.description }}</td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px"></td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Certified Payroll Y/N</td>
        <td style="width: 20%">
          {{ getFormDetail('labor_certified_payroll') == 1 ? 'Yes' : 'No' }}
        </td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Local WH</td>
        <td style="width: 20%">{{ getFormDetail('code') }}</td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Tax Status</td>
        <td style="width: 20%">
          {{ getFormArrayDetail(taxStatusData, 'id', getFormDetail('sales_tax_status_id'), 'name') }}
        </td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px"></td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
        <td style="width: 20%"></td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Project Type</td>
        <td style="width: 20%">
          {{ getFormArrayDetail(projectTypeData, 'id', getFormDetail('project_type_id'), 'name') }}
        </td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Project Industry</td>
        <td style="width: 20%">
          {{ getFormArrayDetail(projectIndustryData, 'id', getFormDetail('project_industry_id'), 'name') }}
        </td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Contract Total</td>
        <td style="width: 20%">$ {{ getProjectTotal('contract_total') | number: '1.2-2' }}</td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
      <tr>
        <td style="width: 40%; letter-spacing: 4px">Estimated Cost</td>
        <td style="width: 20%">$ {{ getProjectTotal('estimated_cost') | number: '1.2-2' }}</td>
        <td style="width: 20%">-</td>
        <td style="width: 20%">-</td>
      </tr>
    </tbody>
  </table>
</div>
